/*
 * assets/sofsy-track.js — the ONE place the theme emits its own events (Round 6, storefront #49, BUILD_MAP C5).
 *
 * Contract: the event dictionary (zao, domains/sofsy/01-sales-marketing/shopify/analytics/EVENT_DICTIONARY.md) at
 * 88fac8e: v1.4 plus the tracking lead's ITEM 17 addendum (Clarity's size events also count the drawer's pills,
 * option b). 88fac8e supersedes 49af649 (v1.4, the tracking lead's version after the step 8 gate); v1.1 at 9db96e5 was
 * the build's first contract (zao#225). Plus build protocol ITEM 15. Names here equal the dictionary's section 5,
 * name for name (36), plus #63 A16's bag_care_set_view and bag_care_set_add (38; in dictionary v1.5) and #63's
 * low_stock_shown (39; its dictionary row is the tracking lead's to add). A name that is not in REGISTRY is dropped (a console warning only in debug:
 * localStorage 'sofsy:track-debug' = '1'), so a typo fails in testing instead of starting a second series.
 *
 *   window.sofsyTrack(name, props)   every theme event: assets/sofsy-pdp.js, qty-drawer.js, bag.js call it, and the
 *                                    commerce listeners below call it for the cart writes assets/cart.js reports.
 *
 * Four sinks, each in its own try/catch; tracking never blocks or delays a cart write:
 *   1. Bus:     Shopify.analytics.publish('sofsy:' + name, payload). No gate in the theme: Shopify delivers bus events
 *               only to pixels whose consent purposes are met (and only a custom pixel can subscribe).
 *   2. Clarity: clarity('event', name) for registry entries with clarity:true, only if
 *               Shopify.customerPrivacy.analyticsProcessingAllowed() (false when the API is missing; the theme's own
 *               hasConsent() is inert, storefront #39). Events fired before Shopify.loadFeatures resolves the
 *               consent-tracking-api are queued (at most 50), then flushed or dropped when it resolves, and dropped
 *               if it has not resolved after 5 s.
 *               Twins stay bus only (clarity:false), because assets/clarity-tagging.js already sends them to Clarity,
 *               ungated, and its 8 events stay unchanged at launch: checkout_clicked, colour_swatch_clicked and
 *               size_selected (the third twin is the tracking lead's decision, dictionary v1.4 section 3). Moving one
 *               later is this flag plus deleting its line in clarity-tagging.js. A size chosen in the quantity drawer
 *               reaches Clarity's size_selected (or size_unavailable_clicked when sold out) from clarity-tagging.js
 *               too, which also watches the drawer's pills ([data-qd-pill]): the tracking lead's ITEM 17 decision,
 *               option (b), 2 Oct (dictionary 88fac8e). Its bus twin here stays clarity:false in the registry.
 *   3. Klaviyo "Added to Cart" (metric UsSsZt, the live Cart Abandon flow Sx4yCT's trigger): replaces the product
 *               page's fetch wrapper (templates/product.json custom_liquid_hH3PnT, deleted in the same commit).
 *               ONE event per successful add (never per line), built from the 'sofsy:cart-added' detail, and ONE for
 *               a partly kept add (a 422 where Shopify kept some units: 'sofsy:cart-add-failed' with units kept),
 *               built from the kept quantities. Never for the sources bag_swap and bag_undo, never for a full
 *               refusal (nothing kept), never for a change taken back off (rolledBack).
 *               Same metric name, same _learnq call, same payload keys and units as the wrapper (ITEM 15), plus
 *               $event_id, StorefrontCart: true, and Internal: true for internal traffic. No theme consent gate:
 *               klaviyo.js applies its own EU/UK/CH suppression, as today; the consent repair is storefront #39.
 *
 *   4. Beacon:  the exit events (EXIT_EVENTS: page.exit, bag.checkout.tap, bag.checkout.start, perf.checkout.nav) and
 *               every tap on a same-origin link that loads the next page also go straight to chopsticks
 *               (fetch keepalive, credentials 'omit', to https://chopsticks.sofsy.com/e, body {schema_version 1, pixel_version
 *               'theme-<RELEASE>', source 'beacon', events [one]}) at emit time, because the bus copy is relayed to the
 *               pixel too late to survive the navigation (zao audit 2026-10-04 F-10, N-01). Same event_id, consent
 *               and traffic_type as the bus payload; the receiver keeps whichever copy arrives first. Only with
 *               analytics consent at fire time; BEACON_MODE 'all' (P2) sends from every consented browser ('internal': only staff).
 *
 * Common fields on every event (dictionary 3.1): event_id (UUID v4), ts, page_type and template (#clarity-ctx),
 * product_id / variant_id when the event is about one product, currency (Shopify.currency.active), theme_id,
 * release 'r6', traffic_type 'internal' only with the cookie sofsy_internal=1, consent {a, m, s} at fire time or
 * null, and exp: the A/B arms this browser is in (ref benmay-git/zao#612), window.sofsyExp.string from
 * snippets/sofsy-exp.liquid, e.g. "t1:b" or "ho:0,t1:a2", only when it is not empty (a browser in no test sends no
 * exp, exactly as before). A caller's props can never set it. No personal data: ids, sizes, shade names, counts and
 * money only.
 *   One documented exception (sign-ups as leads, SofsyTrack.signupSuccess below; zao
 *   domains/sofsy/01-sales-marketing/shopify/analytics/SIGNUP_LEAD_CONVERSIONS_2026-10-05.md): a sign-up counted as a
 *   lead (lead: 1) may carry `em`, the SHA-256 hex of her trimmed, lower-cased address (Meta's normalisation), on its
 *   bus event, and the window event 'sofsy:lead' may carry `em_google` (Google's normalisation), both ONLY with
 *   marketing + sale of data consent and no Global Privacy Control at fire time. The address itself is hashed inside
 *   this file and never stored, put in the page, or sent by this file.
 *
 * Internal traffic (zao analytics/DESIGN_2026-10-03_INTERNAL_TRAFFIC_MARKING.md layer 1, zao#228): the mark is the
 * cookie sofsy_internal=1 (path /, SameSite Lax, 400 days, Secure on https) plus its localStorage mirror
 * 'sofsy:internal' = '1'. It is set before the page's first event (the late admin-bar check below excepted) when
 * any of these holds:
 *   - '?sofsy_internal=1' in the address (the manual link and the office QR code);
 *   - '?_sc=1' in the address with a Shopify admin referrer (admin.shopify.com or <shop>.myshopify.com/admin): admin's
 *     "View store" link. Without that referrer (an admin link pasted into a post or an email) it marks that page view
 *     only, writes nothing and sends no Clarity tag;
 *   - #sofsy-internal-ctx says internal: a logged-in customer tagged "Internal team", or whose email is on
 *     sofsy.com, benmay.io, kobellakade.com or oomee.com (snippets/sofsy-internal-context.liquid; a boolean only);
 *   - the theme editor (Shopify.designMode), or Shopify's admin or preview bar (#admin-bar-iframe, #preview-bar-iframe;
 *     injected late, so checked again 1.5 s after load: events sent before then go unmarked, Clarity's tag covers the
 *     whole session);
 *   - the cookie or the mirror is already there. Re-stamping on every page view restarts Safari's 7-day cap on script
 *     cookies; the mirror brings a cookie back after Safari expired it.
 * '?sofsy_internal=0' clears the cookie and the mirror, and nothing marks that page view; a logged-in internal
 * customer is marked again on her next page (to stay unmarked, log out). Both parameters are then taken out of the
 * address bar (history.replaceState) so they are not shared onward. The chopsticks pixel keeps the same cookie, mirror
 * and domain list (zao benmay-io/workers/chopsticks/pixel.js). With the mark, Clarity also gets
 * clarity('set', 'traffic_type', 'internal') once per page, through the same gate and queue.
 *
 * Cart events this file listens to (assets/cart.js dispatches them; the bag state is snippets/bag-state-json.liquid):
 *   sofsy:cart-added       {items (quantities ADDED), response, source, before, after, quiet}  -> bag_items_added,
 *                          shipping_threshold_crossed, Klaviyo Added to Cart
 *   sofsy:cart-add-failed  {items, source, status, description, cartChanged, partial, rolledBack, rateLimited,
 *                          network, before, after}                                           -> bag_add_failed
 *                          (+ bag_items_added {partial:true}, shipping_threshold_crossed and Klaviyo Added to Cart
 *                          when Shopify added part of it and kept it)
 *   sofsy:cart-updated     {updates, cart, source, before, after}                            -> shipping_threshold_crossed
 *   sofsy:bag-opened       {source: add | header | return | checkout_return, pending}        -> view_cart
 *   sofsy:bag-add-settled  {ok, cartChanged} (zao#617: the add that opened the bag at once)  -> the held view_cart
 *   sofsy:bag-checkout     (the bag's checkout submit)                                       -> checkout_clicked
 * 'sofsy:gift-cleanup' is deliberately NOT listened to: the one-off removal of old gift lines (and its rare put-back
 * add) is not a shopper action, so it sends no bag_items_added, no Klaviyo event, no shipping_threshold_crossed and
 * no view_cart (build protocol ITEM 15, s07b review N5).
 *
 * Taxonomy v2.0 (storefront #63 F, zao#455; dictionary v2.0 section 9): hierarchical surface.component.action names.
 *   - Tap layer: one delegated click/change listener (below) reads data-sofsy-track="pdp.size.tap" on every interactive
 *     element of the product page, quantity drawer, bag, header, menus and footer, with its value (colour, size,
 *     quantity, image index), element id, variant / product / shade, link kind and position; a few elements other
 *     scripts build are named by selector (AUTO); anything else interactive is page.other.tap.
 *   - Outcome layer: the 38 v1.5 names keep their bus and Clarity names for 30 days (ALIASES; payload ev = the new
 *     name), plus qd.row.qty_change, bag.line.qty_change, pdp.gallery.slide_view (index, dwell, swipe / arrow / thumb
 *     / wheel / key), pdp.gallery.summary, page.scroll.depth, page.exit, page.error.js (where: one of the theme's own
 *     files, else a closed host class; kind: error | muted | rejection; platform: ios | android | desktop | other;
 *     since zao#617 also msg, BUILT from an allowlist, never free text, no hash: error type | our phrase | code paths
 *     (errorMsg), src_host, the script's host name only, and line / col; never the stack. Ben's yes, 5 Oct, MC err1).
 *   - r6.1 (spec 3.2-3.14): search.predictive.view, search.results.view, collection.filter.apply, pdp.reviews.view,
 *     pdp.reviews.load, email.form.view, email.signup.success / fail, page.not_found.view, account.login.submit and
 *     the email-only back-in-stock form's notify.request.success / fail are observed here (watchOutcomes); qd.close
 *     and qd.error.view come from assets/qty-drawer.js, bag.update.fail from assets/bag.js, the notify sheet's
 *     notify.request.* from assets/notify-me.js. The tap layer also covers the collection, search, login and account
 *     drawer surfaces.
 *   - perf.*: tap -> visible result from Performance marks (qd.open, bag.open, bag.update, gallery.slide,
 *     checkout.nav; page.nav across a page load).
 *   - Every event: ev, tv, layer, page_view_id, seq, t_ms (since the page started loading), dt_ms and prev (since,
 *     and the name of, the previous event in this tab, across pages: sessionStorage 'sofsy:track-last').
 *   SofsyTrack.untagged() lists, in the console, interactive elements on the page that have no name.
 *
 * Never: gtag, fbq, dataLayer, a window.fetch / XMLHttpRequest patch, or a second copy of Shopify's standard events
 * (product_added_to_cart and the rest come from Shopify; GA4, Meta and Google Ads read those).
 *   One documented exception: assets/signup-conversions.js (loaded only when the theme setting "Send email sign-ups
 *   to Google and Meta as leads" is on) is the ONE theme file allowed to call gtag (through the page's dataLayer) and
 *   the Meta app's own fbq, and only for a sign-up this file decided is a lead ('sofsy:lead' with lead: 1). This file
 *   still never calls either, and no theme file ever defines fbq or loads fbevents.js (layout/theme.liquid, 21 Apr).
 * Loaded deferred from layout/theme.liquid, before the page scripts that call it. Never give it script-reload.
 */
(() => {
  'use strict';

  if (typeof window.sofsyTrack === 'function' && window.SofsyTrack) return;

  const RELEASE = 'r6.1';
  const BUS_PREFIX = 'sofsy:';
  const CLARITY_QUEUE_MAX = 50;
  const CLARITY_WAIT_MS = 5000;
  const INTERNAL_COOKIE = 'sofsy_internal';
  const INTERNAL_MAX_AGE = 34560000; // 400 days
  const INTERNAL_MIRROR = 'sofsy:internal'; // localStorage; the chopsticks pixel reads and writes the same key
  const ADMIN_PARAM = '_sc'; // Shopify admin's "View store" adds ?_ab=0&_fd=0&_sc=1
  const ADMIN_BAR_WAIT_MS = 1500; // after load, when Shopify's admin and preview bars are in the page
  const DEBUG_KEY = 'sofsy:track-debug';
  const KLAVIYO_METRIC = 'Added to Cart'; // the metric name UsSsZt has today; a new name would be a new metric
  const CART_RETRY_MS = 1500;
  const RECENT_MAX = 50;

  /* ---------- the registry: dictionary v1.1 section 5, name for name (36), + #63 A16's two (38) ---------- */
  const REGISTRY = Object.freeze({
    // 5.1 product page (assets/sofsy-pdp.js)
    size_guide_help_tapped: { clarity: true },
    info_tab_opened: { clarity: true },
    privilege_section_viewed: { clarity: true },
    delivery_block_viewed: { clarity: true },
    size_selected: { clarity: false }, // twin (dictionary v1.4 section 3): clarity-tagging.js sends page + drawer pills
    colour_swatch_clicked: { clarity: false }, // twin (dictionary 3, "bus-only twins")
    // 5.2 quantity drawer (assets/qty-drawer.js)
    qty_drawer_opened: { clarity: true },
    sticky_atc_tapped: { clarity: true },
    drawer_size_tapped: { clarity: true },
    drawer_notify_tapped: { clarity: true },
    complete_set_line_tapped: { clarity: true },
    complete_set_drawer_tapped: { clarity: true },
    quantity_rung_selected: { clarity: true },
    // 5.3 add to bag (this file, from assets/cart.js)
    bag_items_added: { clarity: true },
    bag_add_failed: { clarity: true },
    // 5.4 bag (assets/bag.js; view_cart, shipping_threshold_crossed and checkout_clicked from this file)
    view_cart: { clarity: true },
    bag_closed: { clarity: true },
    bag_scrolled: { clarity: true },
    bag_header_revealed: { clarity: true },
    bag_line_change_opened: { clarity: true },
    bag_colour_changed: { clarity: true },
    bag_size_changed: { clarity: true },
    bag_soldout_shade_tapped: { clarity: true },
    bag_line_remove_asked: { clarity: true },
    bag_line_remove_kept: { clarity: true },
    bag_line_removed: { clarity: true },
    bag_line_undone: { clarity: true },
    bag_photo_tapped: { clarity: true },
    complete_set_viewed: { clarity: true },
    complete_set_plus_tapped: { clarity: true },
    complete_set_link_tapped: { clarity: true },
    complete_set_added: { clarity: true },
    complete_set_completed: { clarity: true },
    complete_set_photo_tapped: { clarity: true },
    // #63 A16, The Care Set (v1.4 registry naming, MASTER 3 Oct; the dotted #63 F names come with their alias map in the tracking release)
    bag_care_set_view: { clarity: true },
    bag_care_set_add: { clarity: true },
    // #63 low-stock line (Ben, 3 Oct): "Only N left" shown, {place: pdp | drawer, n, variant_id}, once per variant per
    // page view (assets/sofsy-pdp.js, assets/qty-drawer.js). Its dictionary row is the tracking lead's to add.
    low_stock_shown: { clarity: true },
    shipping_threshold_crossed: { clarity: true },
    checkout_clicked: { clarity: false } // twin
  });

  /* ---------- taxonomy v2.0: hierarchical surface.component.action names (storefront #63 F, zao#455) ----------
   * Three layers, named by their last word:
   *   tap      `*.tap` / `*.change`: one per tap on a tagged element, from the delegated listener below
   *            (data-sofsy-track="pdp.size.tap" on the element). The raw "she touched this" record, every tap.
   *   outcome  what the tap did (pdp.size.select, bag.open, qd.row.qty_change, pdp.gallery.slide_view): the 38
   *            v1.5 names above (published under their v1.5 names while the alias map lasts, payload ev = the new
   *            name) and the new outcome names here.
   *   perf     perf.*: tap -> visible result, in ms (Performance marks; perf.page.nav across a page load).
   * Every event carries ev (this name), tv (taxonomy version), layer, page_view_id, seq, t_ms (ms since the page
   * started loading), dt_ms and prev (ms since, and the name of, the previous event in this tab, across pages).
   * `perf` on a tap entry names the result its timer waits for. A name that is in neither registry is dropped. */
  const TAXONOMY_VERSION = '2.0';
  const TAXONOMY = Object.freeze({
    // page level (every page)
    'page.skip_link.tap': { clarity: true },
    'page.other.tap': { clarity: false }, // a tap on an interactive element outside the tagged surfaces
    'page.scroll.depth': { clarity: false },
    'page.exit': { clarity: false },
    'page.error.js': { clarity: true },
    // A/B experiments (zao#612): the tested part was shown to a browser in that test, {key, arm}; once per test per
    // page view, sent by window.sofsyExp.expose(key) (snippets/sofsy-exp.liquid). The readout counts these.
    'exp.exposure': { clarity: false },
    'popup.country.close.tap': { clarity: true },
    'popup.country.search.tap': { clarity: true },
    'popup.country.option.tap': { clarity: true },
    'popup.consent.tap': { clarity: true },
    'popup.klaviyo_form.tap': { clarity: true },
    'chat.facade.tap': { clarity: true },
    'chat.open.tap': { clarity: true },
    'chat.close.tap': { clarity: true },
    'announce.link.tap': { clarity: true },
    'skin_picker.open.tap': { clarity: true },
    'skin_picker.shade.tap': { clarity: true },
    'skin_picker.confirm.tap': { clarity: true },
    // header and menus
    'header.menu.tap': { clarity: true },
    'header.logo.tap': { clarity: true },
    'header.nav.tap': { clarity: true },
    'header.mega.tile.tap': { clarity: true },
    'header.mega.link.tap': { clarity: true },
    'header.mega.shop_by.tap': { clarity: true },
    'header.search.tap': { clarity: true },
    'header.search_link.tap': { clarity: true },
    'header.account.tap': { clarity: true },
    'header.bag.tap': { clarity: true, perf: 'bag_open' },
    'menu.back.tap': { clarity: true },
    'menu.parent.tap': { clarity: true },
    'menu.child.tap': { clarity: true },
    'menu.account.tap': { clarity: true },
    'search.input.tap': { clarity: true },
    'search.submit.tap': { clarity: true },
    'search.term.tap': { clarity: true },
    'search.suggestion.tap': { clarity: true },
    'search.collection.tap': { clarity: true },
    'search.close.tap': { clarity: true },
    'quick_nav.link.tap': { clarity: true },
    // footer
    'footer.newsletter.email.tap': { clarity: true },
    'footer.newsletter.submit.tap': { clarity: true },
    'footer.newsletter.privacy.tap': { clarity: true },
    'footer.newsletter.privacy_link.tap': { clarity: true },
    'footer.link.tap': { clarity: true },
    'footer.heading.tap': { clarity: true },
    'footer.country.tap': { clarity: true },
    'footer.country.change': { clarity: true },
    'footer.country.option.tap': { clarity: true },
    'footer.country_update.tap': { clarity: true },
    'footer.language.tap': { clarity: true },
    'footer.language.change': { clarity: true },
    'footer.language.option.tap': { clarity: true },
    'footer.language_update.tap': { clarity: true },
    // product page
    'pdp.colour.tap': { clarity: true },
    'pdp.size.tap': { clarity: true },
    'pdp.option.change': { clarity: true },
    'pdp.variant.change': { clarity: true },
    'pdp.size_guide.tap': { clarity: true },
    'pdp.size_guide_link.tap': { clarity: true },
    'pdp.size_guide.close.tap': { clarity: true },
    'pdp.size_chart.units.tap': { clarity: true },
    'pdp.size_chart.gender.tap': { clarity: true },
    'pdp.size_chart.help.tap': { clarity: true },
    'pdp.size_chart.fitting_room.tap': { clarity: true },
    'pdp.size_chart.chat.tap': { clarity: true },
    'pdp.size_menu.size.tap': { clarity: true },
    'pdp.size_menu.qty.tap': { clarity: true },
    'pdp.size_menu.atb.tap': { clarity: true, perf: 'bag_open' },
    'pdp.atb.tap': { clarity: true, perf: 'qd_open' },
    'pdp.cts.tap': { clarity: true, perf: 'qd_open' },
    'pdp.qty_minus.tap': { clarity: true },
    'pdp.qty_input.tap': { clarity: true },
    'pdp.qty_plus.tap': { clarity: true },
    'pdp.notify.tap': { clarity: true },
    'pdp.notify_form.email.tap': { clarity: true },
    'pdp.notify_form.country.change': { clarity: true },
    'pdp.notify_form.phone.tap': { clarity: true },
    'pdp.notify_form.submit.tap': { clarity: true },
    'pdp.notify_form.news.tap': { clarity: true }, // zao#617: the optional news box (its checked state)
    'pdp.notify_form.close.tap': { clarity: true },
    'pdp.bis_form.email.tap': { clarity: true },
    'pdp.bis_form.submit.tap': { clarity: true },
    'pdp.info_tab.tap': { clarity: true },
    'pdp.info_popup.tap': { clarity: true },
    'pdp.info_popup_link.tap': { clarity: true },
    'pdp.popup.close.tap': { clarity: true },
    'pdp.accordion.tap': { clarity: true },
    'pdp.contact.email.tap': { clarity: true },
    'pdp.contact.phone.tap': { clarity: true },
    'pdp.share.tap': { clarity: true },
    'pdp.share.url.tap': { clarity: true },
    'pdp.share.copy.tap': { clarity: true },
    'pdp.share.close.tap': { clarity: true },
    'pdp.pickup.refresh.tap': { clarity: true },
    'pdp.reviews.widget.tap': { clarity: true },
    'pdp.gallery.prev.tap': { clarity: true, perf: 'slide' },
    'pdp.gallery.next.tap': { clarity: true, perf: 'slide' },
    'pdp.gallery.dot.tap': { clarity: true, perf: 'slide' },
    'pdp.gallery.thumb.tap': { clarity: true, perf: 'slide' },
    'pdp.gallery.thumb_prev.tap': { clarity: true, perf: 'slide' },
    'pdp.gallery.thumb_next.tap': { clarity: true, perf: 'slide' },
    'pdp.gallery.image.tap': { clarity: true },
    'pdp.gallery.video.tap': { clarity: true },
    'pdp.gallery.xr.tap': { clarity: true },
    'pdp.gallery.slide_view': { clarity: true },
    'pdp.gallery.summary': { clarity: false },
    'swatch.colour.tap': { clarity: true },
    'swatch.current.tap': { clarity: true },
    'card.product.image.tap': { clarity: true },
    'card.product.title.tap': { clarity: true },
    'card.slider.prev.tap': { clarity: true },
    'card.slider.next.tap': { clarity: true },
    // quantity drawer
    'qd.close.tap': { clarity: true },
    'qd.add.tap': { clarity: true, perf: 'bag_open' },
    'qd.cts.tap': { clarity: true },
    'qd.row.size_open.tap': { clarity: true },
    'qd.row.size.tap': { clarity: true },
    'qd.row.notify.tap': { clarity: true },
    'qd.row.qty_minus.tap': { clarity: false }, // high frequency; qd.row.qty_change carries the numbers
    'qd.row.qty_plus.tap': { clarity: false },
    'qd.row.qty_change': { clarity: false },
    // bag
    'bag.close.tap': { clarity: true },
    'bag.update.tap': { clarity: true },
    'bag.checkout.tap': { clarity: true, perf: 'checkout' },
    'bag.line.name.tap': { clarity: true }, // MC n29: the product name in the bag opens its page (outcome: bag_photo_tapped place line_name)
    'bag.line.colour_open.tap': { clarity: true },
    'bag.line.colour.tap': { clarity: true, perf: 'bag_update' },
    'bag.line.size_open.tap': { clarity: true },
    'bag.line.size.tap': { clarity: true, perf: 'bag_update' },
    'bag.line.qty_minus.tap': { clarity: false, perf: 'bag_update' },
    'bag.line.qty_plus.tap': { clarity: false, perf: 'bag_update' },
    'bag.line.qty_select.change': { clarity: false },
    'bag.line.qty_change': { clarity: true },
    'bag.line.remove.tap': { clarity: true },
    'bag.line.remove_confirm.tap': { clarity: true, perf: 'bag_update' },
    'bag.line.remove_keep.tap': { clarity: true },
    'bag.line.undo.tap': { clarity: true, perf: 'bag_update' },
    'bag.cts.plus.tap': { clarity: true, perf: 'bag_update' },
    'bag.cts.link.tap': { clarity: true, perf: 'bag_update' },
    'bag.care_set.plus.tap': { clarity: true, perf: 'bag_update' },
    'bag.care_set.link.tap': { clarity: true, perf: 'bag_update' },
    // r6.1: collection, search and account pages (tap layer)
    'collection.sort.change': { clarity: true }, // the sort <select>: value = Shopify's sort_by key
    'collection.type.tap': { clarity: true },
    'collection.load_more.tap': { clarity: true }, // value = the page the tap loads
    'collection.facet.group.tap': { clarity: true },
    'collection.facet.option.tap': { clarity: true },
    'collection.facet.price.tap': { clarity: true }, // the price range: the tap only, never the typed amount
    'collection.facet.remove.tap': { clarity: true },
    'collection.facet.clear.tap': { clarity: true },
    'collection.facet.more.tap': { clarity: true },
    'collection.facet.submit.tap': { clarity: true },
    'collection.filters.open.tap': { clarity: true },
    'collection.filters.close.tap': { clarity: true },
    'collection.filters.apply.tap': { clarity: true },
    'search.result.link.tap': { clarity: true },
    'card.article.link.tap': { clarity: true },
    'section.image_text.button.tap': { clarity: true },
    'account.nav.link.tap': { clarity: true },
    'account.login.email.tap': { clarity: true },
    'account.login.password.tap': { clarity: true },
    'account.login.sign_in.tap': { clarity: true },
    'account.login.forgot.tap': { clarity: true },
    'account.login.register.tap': { clarity: true },
    'account.recover.email.tap': { clarity: true },
    'account.recover.submit.tap': { clarity: true },
    'account.recover.cancel.tap': { clarity: true },
    'account.guest.continue.tap': { clarity: true },
    'account.drawer.close.tap': { clarity: true },
    'account.drawer.email.tap': { clarity: true },
    'account.drawer.submit.tap': { clarity: true },
    // zao#617 welcome drawer (assets/welcome-drawer.js). drawer.open {entry: menu | auto | exit | campaign, offer},
    // drawer.close {how: x | escape | yield}, drawer.signup.success {offer, entry}, drawer.signup.fail {offer, reason:
    // invalid_email | other}. offer is 'gloves' | 'pct10'. Never the address.
    'drawer.open': { clarity: true },
    'drawer.close': { clarity: true },
    'drawer.signup.success': { clarity: true },
    'drawer.signup.fail': { clarity: true },
    // r6.1 outcome layer (spec sections 3.2-3.14): what a tap or a page did
    'search.predictive.view': { clarity: true },
    'search.results.view': { clarity: true },
    'collection.filter.apply': { clarity: true },
    'pdp.reviews.view': { clarity: true },
    'pdp.reviews.load': { clarity: false },
    'notify.request.success': { clarity: true },
    'notify.request.fail': { clarity: true },
    'pdp.notify_form.blocked': { clarity: false }, // zao#617: the bot trap kept a send back {reason: honeypot | too_fast}
    'qd.close': { clarity: true },
    'qd.error.view': { clarity: true },
    'bag.update.fail': { clarity: true },
    'email.form.view': { clarity: true },
    'email.signup.success': { clarity: true },
    'email.signup.fail': { clarity: true },
    'page.not_found.view': { clarity: true },
    'account.login.submit': { clarity: true },
    // zao#617: Secure checkout in view, once per bag open (bag.js; {ms_since_open, scrolled}). Bus only: every open
    // would send one, too many for Clarity's custom events.
    'bag.checkout.impression': { clarity: false },
    // perf: tap -> visible result
    'perf.qd.open': { clarity: false },
    'perf.bag.open': { clarity: false },
    'perf.bag.update': { clarity: false },
    'perf.gallery.slide': { clarity: false },
    'perf.checkout.nav': { clarity: false },
    'perf.page.nav': { clarity: false },
    // the v1.5 names' new names (outcome layer; ALIASES below)
    'pdp.size_guide.help_open': { clarity: true },
    'pdp.info_tab.open': { clarity: true },
    'pdp.privilege.view': { clarity: true },
    'pdp.delivery.view': { clarity: true },
    'pdp.size.select': { clarity: false },
    'pdp.colour.select': { clarity: false },
    'qd.open': { clarity: true },
    'pdp.sticky_bar.atb_press': { clarity: true },
    'qd.row.size_open': { clarity: true },
    'qd.row.notify_open': { clarity: true },
    'pdp.cts.open': { clarity: true },
    'qd.cts.fill': { clarity: true },
    'qd.rung.select': { clarity: true },
    'bag.items.add': { clarity: true },
    'bag.items.add_fail': { clarity: true },
    'bag.open': { clarity: true },
    'bag.close': { clarity: true },
    'bag.list.scroll': { clarity: true },
    'bag.header.reveal': { clarity: true },
    'bag.line.change_open': { clarity: true },
    'bag.line.colour_change': { clarity: true },
    'bag.line.size_change': { clarity: true },
    'bag.line.soldout_shade': { clarity: true },
    'bag.line.remove_ask': { clarity: true },
    'bag.line.remove_keep': { clarity: true },
    'bag.line.remove': { clarity: true },
    'bag.line.undo': { clarity: true },
    'bag.photo.press': { clarity: true },
    'bag.cts.view': { clarity: true },
    'bag.cts.plus_press': { clarity: true },
    'bag.cts.link_press': { clarity: true },
    'bag.cts.add': { clarity: true },
    'bag.cts.complete': { clarity: true },
    'bag.cts.photo_press': { clarity: true },
    'bag.care_set.view': { clarity: true },
    'bag.care_set.add': { clarity: true },
    'bag.shipping.threshold_cross': { clarity: true },
    'bag.checkout.start': { clarity: false },
    'pdp.low_stock.view': { clarity: true }
  });

  // The alias map: every v1.5 name -> its v2.0 name, kept for 30 days after the r6.1 release (until Fri 6 Nov 2026).
  // Until then a v1.5 call keeps its bus and Clarity name (so the receiver, saved Clarity filters and the v1.5 checks
  // see no change) and its payload carries ev = the v2.0 name, so the warehouse can read every event by ev from day
  // one. Retiring an alias = renaming its call site to the v2.0 name and deleting its line here and in REGISTRY.
  const ALIASES = Object.freeze({
    size_guide_help_tapped: 'pdp.size_guide.help_open',
    info_tab_opened: 'pdp.info_tab.open',
    privilege_section_viewed: 'pdp.privilege.view',
    delivery_block_viewed: 'pdp.delivery.view',
    size_selected: 'pdp.size.select',
    colour_swatch_clicked: 'pdp.colour.select',
    qty_drawer_opened: 'qd.open',
    sticky_atc_tapped: 'pdp.sticky_bar.atb_press',
    drawer_size_tapped: 'qd.row.size_open',
    drawer_notify_tapped: 'qd.row.notify_open',
    complete_set_line_tapped: 'pdp.cts.open',
    complete_set_drawer_tapped: 'qd.cts.fill',
    quantity_rung_selected: 'qd.rung.select',
    bag_items_added: 'bag.items.add',
    bag_add_failed: 'bag.items.add_fail',
    view_cart: 'bag.open',
    bag_closed: 'bag.close',
    bag_scrolled: 'bag.list.scroll',
    bag_header_revealed: 'bag.header.reveal',
    bag_line_change_opened: 'bag.line.change_open',
    bag_colour_changed: 'bag.line.colour_change',
    bag_size_changed: 'bag.line.size_change',
    bag_soldout_shade_tapped: 'bag.line.soldout_shade',
    bag_line_remove_asked: 'bag.line.remove_ask',
    bag_line_remove_kept: 'bag.line.remove_keep',
    bag_line_removed: 'bag.line.remove',
    bag_line_undone: 'bag.line.undo',
    bag_photo_tapped: 'bag.photo.press',
    complete_set_viewed: 'bag.cts.view',
    complete_set_plus_tapped: 'bag.cts.plus_press',
    complete_set_link_tapped: 'bag.cts.link_press',
    complete_set_added: 'bag.cts.add',
    complete_set_completed: 'bag.cts.complete',
    complete_set_photo_tapped: 'bag.cts.photo_press',
    bag_care_set_view: 'bag.care_set.view',
    bag_care_set_add: 'bag.care_set.add',
    shipping_threshold_crossed: 'bag.shipping.threshold_cross',
    checkout_clicked: 'bag.checkout.start',
    low_stock_shown: 'pdp.low_stock.view'
  });

  // Outcome events that end a perf timer started by a tap: the result is on screen (after the next paint).
  const RESOLVES = Object.freeze({ qty_drawer_opened: 'qd_open', view_cart: 'bag_open' });
  const PERF_EVENTS = Object.freeze({
    qd_open: 'perf.qd.open',
    bag_open: 'perf.bag.open',
    bag_update: 'perf.bag.update',
    slide: 'perf.gallery.slide',
    checkout: 'perf.checkout.nav'
  });

  // Events about the product on the page: product_id / variant_id come from the page when the caller gives none.
  const PAGE_EVENTS = new Set([
    'size_guide_help_tapped',
    'info_tab_opened',
    'privilege_section_viewed',
    'delivery_block_viewed',
    'colour_swatch_clicked',
    'qty_drawer_opened',
    'sticky_atc_tapped',
    'complete_set_line_tapped',
    'complete_set_drawer_tapped',
    'quantity_rung_selected',
    'low_stock_shown'
  ]);

  // Fields every event carries that a caller's props may not overwrite.
  const RESERVED = [
    'event_id',
    'ts',
    'theme_id',
    'release',
    'traffic_type',
    'consent',
    'ev',
    'tv',
    'layer',
    'page_view_id',
    'seq',
    't_ms',
    'dt_ms',
    'prev',
    'exp', // the A/B arms, from window.sofsyExp only (zao#612)
    'em' // only signupSuccess sets it (its `top` argument to emit), never a caller's props
  ];

  // assets/cart.js write sources -> the dictionary's `source` values (5.3).
  const ADD_SOURCES = Object.freeze({
    drawer: 'qty_drawer', // the quantity drawer's Add to Bag
    cts_line: 'qty_drawer', // the same button, the drawer opened from the page's Complete the Set line
    bag_cts: 'bag_complete_set', // + on one card in the bag
    bag_cts_link: 'bag_complete_set', // the bag's "Complete the Set" link (every card)
    bag_care: 'bag_care_set', // + on one card of The Care Set (#63 A16)
    bag_care_link: 'bag_care_set', // The Care Set's "Complete the Care Set" link (every card, one request)
    undo: 'bag_undo', // Undo after a removal
    bag_colour: 'bag_swap', // a line's colour change (its add half)
    bag_size: 'bag_swap', // a line's size change (its add half)
    page_form: 'page_form', // the desktop product form (<product-form>)
    size_menu: 'page_form' // today's mobile size sheet, only if the quantity drawer failed to load
  });
  const NO_KLAVIYO = new Set(['bag_swap', 'bag_undo']); // a change or an Undo is not a new add (Q-15)

  /* ---------- small helpers ---------- */
  const has = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  const positiveId = (value) => {
    const n = Number(value);
    return Number.isSafeInteger(n) && n > 0 ? n : null;
  };
  const cents = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? Math.round(n) : null;
  };
  const major = (value) => {
    const c = cents(value);
    return c === null ? null : c / 100;
  };

  const debugOn = () => {
    try {
      return window.localStorage.getItem(DEBUG_KEY) === '1';
    } catch (_) {
      return false;
    }
  };

  const pageContext = (() => {
    try {
      const node = document.getElementById('clarity-ctx');
      return node ? JSON.parse(node.textContent) || {} : {};
    } catch (_) {
      return {};
    }
  })();

  const readCookie = (name) => {
    try {
      const pair = document.cookie.split('; ').find((part) => part.indexOf(`${name}=`) === 0);
      return pair ? decodeURIComponent(pair.slice(name.length + 1)) : null;
    } catch (_) {
      return null;
    }
  };
  /* ---------- internal traffic: marked before the page's first event (header, "Internal traffic") ---------- */
  let internalNow = false; // this page view is internal, even if the browser refuses the cookie
  let internalCleared = false; // '?sofsy_internal=0' on this page view: nothing marks it
  let internalWritten = false; // the mark was written (not a page-view-only mark): Clarity may tag the session
  const isInternal = () => !internalCleared && (internalNow || readCookie(INTERNAL_COOKIE) === '1');
  const readMirror = () => {
    try {
      return window.localStorage.getItem(INTERNAL_MIRROR) === '1';
    } catch (_) {
      return false;
    }
  };
  const writeMark = (on) => {
    try {
      const secure = window.location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = on
        ? `${INTERNAL_COOKIE}=1; path=/; SameSite=Lax; max-age=${INTERNAL_MAX_AGE}${secure}`
        : `${INTERNAL_COOKIE}=; path=/; SameSite=Lax; max-age=0${secure}`;
    } catch (_) {
      /* the mirror may still hold it */
    }
    try {
      if (on) window.localStorage.setItem(INTERNAL_MIRROR, '1');
      else window.localStorage.removeItem(INTERNAL_MIRROR);
    } catch (_) {
      /* the cookie may still hold it */
    }
  };
  const internalCustomer = () => {
    try {
      const node = document.getElementById('sofsy-internal-ctx');
      return node ? (JSON.parse(node.textContent) || {}).internal === true : false;
    } catch (_) {
      return false;
    }
  };
  // Strong: only someone signed in to Shopify admin sees these. They write the mark.
  const adminContext = () => {
    try {
      const S = window.Shopify || {};
      return (
        S.designMode === true ||
        !!document.getElementById('admin-bar-iframe') ||
        !!document.getElementById('preview-bar-iframe')
      );
    } catch (_) {
      return false;
    }
  };
  // The page was opened from Shopify admin (admin.shopify.com, or <shop>.myshopify.com/admin).
  const adminReferrer = () => {
    try {
      const ref = new URL(document.referrer);
      return (
        ref.hostname === 'admin.shopify.com' ||
        (/\.myshopify\.com$/.test(ref.hostname) && ref.pathname.indexOf('/admin') === 0)
      );
    } catch (_) {
      return false;
    }
  };
  const markInternal = () => {
    let url = null;
    try {
      url = new URL(window.location.href);
    } catch (_) {
      /* no address: the other signals still count */
    }
    const param = url ? url.searchParams.get(INTERNAL_COOKIE) : null;
    const fromAdmin = url ? url.searchParams.get(ADMIN_PARAM) === '1' : false;
    if (param === '0') {
      internalCleared = true;
      writeMark(false);
    } else if (
      param === '1' ||
      (fromAdmin && adminReferrer()) ||
      readCookie(INTERNAL_COOKIE) === '1' ||
      readMirror() ||
      internalCustomer() ||
      adminContext()
    ) {
      internalNow = true;
      internalWritten = true;
      writeMark(true); // re-stamped on every page view
    } else if (fromAdmin) {
      // An admin link copied into a post or an email still carries _sc=1: this page view only, no cookie, no mirror,
      // no Clarity tag (Clarity tags the whole session).
      internalNow = true;
    }
    if (!url || !(url.searchParams.has(INTERNAL_COOKIE) || fromAdmin)) return;
    try {
      url.searchParams.delete(INTERNAL_COOKIE);
      if (fromAdmin) url.searchParams.delete(ADMIN_PARAM);
      window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
    } catch (_) {
      /* the parameter stays in the address; the mark is still right */
    }
  };
  try {
    markInternal();
  } catch (_) {
    /* tracking never breaks the page */
  }

  const uuid = () => {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    } catch (_) {
      /* fall through */
    }
    let bytes = null;
    try {
      bytes = window.crypto.getRandomValues(new Uint8Array(16));
    } catch (_) {
      bytes = Uint8Array.from({ length: 16 }, () => Math.floor(Math.random() * 256));
    }
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  };

  const privacy = () => {
    try {
      const api = window.Shopify && window.Shopify.customerPrivacy;
      return api && typeof api.analyticsProcessingAllowed === 'function' ? api : null;
    } catch (_) {
      return null;
    }
  };
  const consentNow = () => {
    const api = privacy();
    if (!api) return null;
    const bit = (method) => {
      try {
        return typeof api[method] === 'function' ? (api[method]() ? 1 : 0) : null;
      } catch (_) {
        return null;
      }
    };
    return { a: bit('analyticsProcessingAllowed'), m: bit('marketingAllowed'), s: bit('saleOfDataAllowed') };
  };
  const analyticsAllowed = () => {
    const api = privacy();
    try {
      return !!(api && api.analyticsProcessingAllowed());
    } catch (_) {
      return false;
    }
  };

  // The bag's JSON (snippets/bag-state-json.liquid), as the last cart write rendered it.
  const bagState = () => {
    try {
      const bag = document.querySelector('cart-items.cart-wrapper');
      if (bag && typeof bag.readBagState === 'function') return bag.readBagState();
      const node = document.getElementById('bag-state');
      return node ? JSON.parse(node.textContent) : null;
    } catch (_) {
      return null;
    }
  };

  const pageProductId = () => {
    const section = document.querySelector('#main-product[product-id]');
    return section ? positiveId(section.getAttribute('product-id')) : null;
  };
  const pageVariantId = () => {
    try {
      const state = window.SofsyPdp && typeof window.SofsyPdp.state === 'function' ? window.SofsyPdp.state() : null;
      return state ? positiveId(state.variantId) : null;
    } catch (_) {
      return null;
    }
  };
  const productOfVariant = (variantId) => {
    const state = bagState();
    const line = state && Array.isArray(state.lines) ? state.lines.find((l) => Number(l.variant_id) === variantId) : null;
    return line ? positiveId(line.product_id) : null;
  };

  // product_id / variant_id when the event is about one product (dictionary 3.1).
  const aboutOneProduct = (name, props) => {
    const out = {};
    let product = positiveId(props.product_id);
    let variant = positiveId(props.variant_id);
    if (!variant && (typeof props.variant === 'number' || typeof props.variant === 'string')) variant = positiveId(props.variant);
    if (!product && (typeof props.product === 'number' || typeof props.product === 'string')) product = positiveId(props.product);
    if (PAGE_EVENTS.has(name) || /^(pdp|qd)\./.test(name)) {
      if (!product) product = pageProductId();
      if (!variant) variant = pageVariantId();
    }
    if (variant && !product) product = productOfVariant(variant);
    if (product) out.product_id = product;
    if (variant) out.variant_id = variant;
    return out;
  };

  // The A/B arms this browser is in (snippets/sofsy-exp.liquid, zao#612): "key:arm" pairs, comma separated, at most
  // 7 (6 tests and the holdout) and 64 characters (the pixel's and the beacon's string cap), or null. Read at every
  // event, never cached. A QA arm (?sofsy_exp=, staff only) is sent only while this page is marked internal
  // (isInternal), so a QA view can never reach a readout as a shopper's.
  const EXP_SHAPE = /^[a-z][a-z0-9]{0,5}:[a-z0-9]{1,3}(?:,[a-z][a-z0-9]{0,5}:[a-z0-9]{1,3}){0,6}$/;
  const expNow = () => {
    try {
      const api = window.sofsyExp;
      if (!api || (api.qa && !isInternal())) return null;
      const text = api.string;
      return typeof text === 'string' && text.length <= 64 && EXP_SHAPE.test(text) ? text : null;
    } catch (_) {
      return null;
    }
  };

  // A plain copy of the caller's props: no DOM nodes, no functions, nothing that cannot be sent.
  const plain = (props) => {
    if (!props || typeof props !== 'object') return {};
    try {
      const copy = JSON.parse(JSON.stringify(props));
      return copy && typeof copy === 'object' && !Array.isArray(copy) ? copy : {};
    } catch (_) {
      return {};
    }
  };

  /* ---------- sink 2: Clarity, behind Shopify's Customer Privacy API ---------- */
  const gate = { state: 'pending', queue: [] }; // pending | ready | expired | missing

  const clarityCall = (args) => {
    try {
      if (typeof window.clarity === 'function') window.clarity(...args);
    } catch (_) {
      /* tracking never breaks the page */
    }
  };

  const toClarity = (args) => {
    try {
      if (gate.state === 'ready') {
        if (analyticsAllowed()) clarityCall(args);
        return;
      }
      if (gate.state === 'pending' && gate.queue.length < CLARITY_QUEUE_MAX) gate.queue.push(args);
      // expired (not resolved within 5 s), missing (no API), or a full queue: dropped
    } catch (_) {
      /* tracking never breaks the page */
    }
  };

  const startGate = () => {
    try {
      const shopify = window.Shopify;
      if (!shopify || typeof shopify.loadFeatures !== 'function') {
        gate.state = 'missing';
        gate.queue.length = 0;
        return;
      }
      const timer = setTimeout(() => {
        if (gate.state !== 'pending') return;
        gate.state = 'expired';
        gate.queue.length = 0;
      }, CLARITY_WAIT_MS);
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
        clearTimeout(timer);
        const queued = gate.queue.splice(0);
        // From now on each Clarity event asks the API at fire time (also after an expiry: later events are checked).
        gate.state = 'ready';
        if (queued.length && analyticsAllowed()) queued.forEach(clarityCall);
      });
    } catch (_) {
      gate.state = 'missing';
      gate.queue.length = 0;
    }
  };

  /* ---------- sink 1: Shopify's customer-event bus ---------- */
  const toBus = (name, payload) => {
    try {
      const analytics = window.Shopify && window.Shopify.analytics;
      if (analytics && typeof analytics.publish === 'function') analytics.publish(BUS_PREFIX + name, payload);
    } catch (_) {
      /* tracking never breaks the page */
    }
  };

  /* ---------- sink 4: the exit beacon, straight to chopsticks (zao audit 2026-10-04 F-10, N-01) ---------- */
  // Events sent in the last moment before a navigation reach the bus, but the page unloads before the Web Pixel
  // Manager relays them to the sandboxed pixel, so they never arrived (0 of 3 checkouts carried bag.checkout.tap).
  // These also go, at emit time, as a beacon from this page: same event_id (the receiver keeps the first copy and
  // ignores the other), consent and traffic_type as the bus payload. Only with analytics consent at fire time
  // (unknown means no). BEACON_MODE is the same switch as pixel.js MODE and worker.js BEACON_MODE (all three change
  // together): 'all' (P2) sends from every consented browser, 'internal' (P1) only from an internal one.
  const BEACON_URL = 'https://chopsticks.sofsy.com/e';
  const BEACON_MODE = 'all'; // P2 since Ben's yes of 4 Oct 2026 (zao#223); 'internal' was P1. Same as zao pixel.js MODE and worker.js BEACON_MODE
  const BEACON_MAX_BYTES = 60000; // under the receiver's 64 KB and the browser's beacon budget
  const EXIT_EVENTS = Object.freeze(['page.exit', 'bag.checkout.tap', 'bag.checkout.start', 'perf.checkout.nav']);
  // Set by this sink, never from the payload's own keys (pixel.js RESERVED, the same five).
  const BEACON_RESERVED = ['event_id', 'ts', 'traffic_type', 'consent', 'page_type'];
  const GA_SESSION_COOKIE = '_ga_9YTEQXNN0Z'; // GA4 stream G-9YTEQXNN0Z, as pixel.js
  const beaconBit = (v) => (v === 1 || v === true ? 1 : v === 0 || v === false ? 0 : null);
  // pixel.js plain(): primitives and short id lists only; a string with '@' or over 64 characters never leaves.
  const beaconValue = (v) => {
    if (typeof v === 'boolean') return v;
    if (typeof v === 'number') return Number.isFinite(v) ? v : undefined;
    if (typeof v === 'string') return v && v.length <= 64 && v.indexOf('@') < 0 ? v : undefined;
    if (Array.isArray(v) && v.length > 0 && v.length <= 50 && v.every((x) => typeof x === 'number' || (typeof x === 'string' && x.length <= 32))) {
      return v.slice();
    }
    return undefined;
  };
  const beaconId = (v) => {
    const m = /(?:^|\/)([1-9]\d{0,19})$/.exec(v === null || v === undefined ? '' : String(v));
    return m ? m[1] : null;
  };
  // _ga = GA1.1.<client id>; _ga_<stream> = GS1.1.<session id>.… or GS2.1.s<session id>$o… (pixel.js, the same rules)
  const gaClientId = (v) => {
    const m = /^GA\d\.\d\.(\d+\.\d+)$/.exec(v || '');
    return m ? m[1] : null;
  };
  const gaSessionId = (v) => {
    const m = /^GS1\.\d\.(\d+)\./.exec(v || '') || /^GS2\.\d\.s(\d+)/.exec(v || '');
    return m ? m[1] : null;
  };
  // One event as pixel.js would send it (its build() for a sofsy:* event), from what this page knows. No client_id:
  // the pixel's comes from Shopify's sandbox, so a beacon row joins its page's other rows by page_view_id.
  const beaconRecord = (name, payload) => {
    const c = payload.consent;
    const out = { name: BUS_PREFIX + name, consent: { a: c.a, m: c.m, s: c.s }, gpc: null };
    try {
      out.gpc = beaconBit(window.navigator ? window.navigator.globalPrivacyControl : undefined);
    } catch (_) {
      /* unknown */
    }
    if (payload.traffic_type === 'internal') out.traffic_type = 'internal';
    if (typeof payload.page_type === 'string') out.page_type = payload.page_type.slice(0, 48);
    out.event_id = payload.event_id;
    out.ts = payload.ts;
    try {
      out.path = window.location.pathname; // the receiver replaces token-like segments before it stores anything
    } catch (_) {
      /* no path */
    }
    const props = {};
    Object.keys(payload)
      .slice(0, 40)
      .forEach((key) => {
        if (BEACON_RESERVED.indexOf(key) >= 0) return;
        const value = beaconValue(payload[key]);
        if (value === undefined) return;
        if (key === 'product_id' || key === 'variant_id') out[key] = beaconId(value);
        else if (key === 'value' && typeof value === 'number') out.value = value;
        else if (key === 'value') props.value = value;
        else if (key === 'currency') out.currency = typeof value === 'string' ? value : null;
        else props[key] = value;
      });
    if (Object.keys(props).length) out.props = props;
    const ga = gaClientId(readCookie('_ga'));
    const gaSession = gaSessionId(readCookie(GA_SESSION_COOKIE));
    if (ga) out.ga_client_id = ga;
    if (gaSession) out.ga_session_id = gaSession;
    return out;
  };
  // `navigates`: a tap on a same-origin link that will load the next page (onTap's own test).
  const beaconWanted = (entry, navigates) => EXIT_EVENTS.indexOf(entry.ev) >= 0 || (navigates === true && entry.layer === 'tap');
  const keepaliveFetch = () => {
    try {
      return typeof window.Request === 'function' && 'keepalive' in window.Request.prototype;
    } catch (_) {
      return false;
    }
  };
  // At most one page.exit beacon per BEACON_EXIT_GAP_MS: a shopper flicking between tabs or apps hides the page
  // again and again, and every request counts against the per-address flood rule on /e (zao DEPLOY_STEPS step 9).
  // The pixel's copy of each page.exit still goes; the receiver deduplicates on event_id.
  const BEACON_EXIT_GAP_MS = 5000;
  let lastExitBeacon = -Infinity;
  const toBeacon = (name, payload) => {
    try {
      const c = payload.consent;
      if (!c || c.a !== 1) return; // no analytics consent at fire time (or no answer): no beacon
      const internal = payload.traffic_type === 'internal';
      if (BEACON_MODE !== 'all' && !internal) return;
      if (name === 'page.exit') {
        const now = Date.now();
        if (now - lastExitBeacon < BEACON_EXIT_GAP_MS) return;
        lastExitBeacon = now;
      }
      const body = JSON.stringify({
        schema_version: 1,
        pixel_version: `theme-${RELEASE}`,
        source: 'beacon',
        events: [beaconRecord(name, payload)]
      });
      if (body.length > BEACON_MAX_BYTES) return;
      // fetch with keepalive outlives the page like a beacon, and credentials 'omit' sends no cookie: sendBeacon always
      // sends the browser's cookies, and chopsticks.sofsy.com is same-site, so every .sofsy.com cookie would go with it.
      // A string body goes as text/plain: no CORS preflight. sendBeacon only where fetch cannot keep the request alive
      // past the page (no fetch, or no keepalive: Firefox before 133 ignores it and would lose the request at unload).
      if (typeof window.fetch === 'function' && keepaliveFetch()) {
        window.fetch(BEACON_URL, { method: 'POST', body, keepalive: true, credentials: 'omit' }).catch(() => {});
        return;
      }
      // The sendBeacon fallback carries every .sofsy.com cookie, so it is for internal browsers only: a shopper's
      // exit event then reaches chopsticks through the pixel alone, as before the beacon existed.
      if (!internal) return;
      const nav = window.navigator;
      if (nav && typeof nav.sendBeacon === 'function') nav.sendBeacon(BEACON_URL, body);
    } catch (_) {
      /* tracking never breaks the page */
    }
  };

  /* ---------- time: ms since the page started loading, and between events ---------- */
  const LOADED_AT = Date.now();
  const perf = () => {
    try {
      const p = window.performance;
      return p && typeof p.now === 'function' ? p : null;
    } catch (_) {
      return null;
    }
  };
  const nowMs = () => {
    const p = perf();
    return p ? p.now() : Date.now() - LOADED_AT;
  };
  const mark = (label) => {
    try {
      const p = perf();
      if (p && typeof p.mark === 'function') p.mark(label);
    } catch (_) {
      /* tracking never breaks the page */
    }
  };
  const measure = (label, start) => {
    try {
      const p = perf();
      if (p && typeof p.measure === 'function') p.measure(label, start);
    } catch (_) {
      /* the start mark was cleared */
    }
  };
  const session = (() => {
    try {
      return window.sessionStorage || null;
    } catch (_) {
      return null;
    }
  })();
  const readSession = (key) => {
    try {
      const raw = session ? session.getItem(key) : null;
      return raw ? JSON.parse(raw) : null;
    } catch (_) {
      return null;
    }
  };
  const writeSession = (key, value) => {
    try {
      if (session) {
        if (value === null) session.removeItem(key);
        else session.setItem(key, JSON.stringify(value));
      }
    } catch (_) {
      /* private mode or full: the next page starts its own chain */
    }
  };

  const LAST_KEY = 'sofsy:track-last'; // {ev, at: epoch ms}: the previous event in this tab, for dt_ms across pages
  const NAV_KEY = 'sofsy:track-nav'; // {from, at: epoch ms}: a tap on a link, for perf.page.nav on the next page
  const CHAIN_MAX_MS = 30 * 60 * 1000; // a gap longer than a session is not "time between steps"
  const pageViewId = uuid();
  const chain = { seq: 0, ev: null, at: null }; // at: epoch ms of the previous event
  (() => {
    const last = readSession(LAST_KEY);
    if (last && typeof last.ev === 'string' && Number.isFinite(last.at) && Date.now() - last.at < CHAIN_MAX_MS) {
      chain.ev = last.ev;
      chain.at = last.at;
    }
  })();

  // The name a call resolves to: a v1.5 name (bus and Clarity keep it; ev = its alias) or a v2.0 name.
  const layerOf = (name) => (/^perf\./.test(name) ? 'perf' : /\.(tap|change)$/.test(name) ? 'tap' : 'outcome');
  const resolve = (name) => {
    if (typeof name !== 'string') return null;
    if (has(REGISTRY, name)) return { ev: ALIASES[name] || name, clarity: REGISTRY[name].clarity, layer: 'outcome' };
    if (has(TAXONOMY, name)) return { ev: name, clarity: TAXONOMY[name].clarity, layer: layerOf(name) };
    return null;
  };

  /* ---------- sofsyTrack ---------- */
  const recent = [];

  function sofsyTrack(name, props) {
    return emit(name, props, null);
  }

  // Events that describe the page rather than a step she took: they get prev / dt_ms, but never become `prev`.
  const OFF_CHAIN = new Set(['page.scroll.depth', 'page.exit', 'page.error.js', 'pdp.gallery.summary']);

  // The place of one event in the chain: seq, t_ms, dt_ms, prev. Taken when it happened, so a tap (sent one tick
  // later, after its handlers ran) still comes before the result its handler sent at once.
  function stampChain(entry, at) {
    const t = typeof at === 'number' && Number.isFinite(at) ? at : nowMs();
    const wall = Date.now() - Math.max(0, nowMs() - t); // epoch ms when it happened
    chain.seq += 1;
    const stamp = {
      seq: chain.seq,
      t_ms: Math.max(0, Math.round(t)),
      dt_ms: chain.at === null ? null : Math.max(0, Math.round(wall - chain.at)),
      prev: chain.ev
    };
    if (entry.layer !== 'perf' && !OFF_CHAIN.has(entry.ev)) {
      chain.ev = entry.ev;
      chain.at = Math.max(chain.at || 0, wall);
      writeSession(LAST_KEY, { ev: chain.ev, at: chain.at });
    }
    return stamp;
  }

  // `at`: when it happened (nowMs()), if earlier than now. `stamp`: its chain place, taken earlier (a tap).
  // `navigates`: a tap on a same-origin link that will load the next page (sink 4 sends it as a beacon too).
  // `top`: top-level fields only this file may set (signupSuccess's `em`); a caller's props can never set them.
  function emit(name, props, at, stamp, navigates, top) {
    try {
      const entry = resolve(name);
      if (!entry) {
        if (debugOn()) console.warn(`sofsyTrack: "${name}" is not in the event dictionary; dropped.`);
        return null;
      }
      const own = plain(props);
      RESERVED.forEach((key) => delete own[key]);
      const about = aboutOneProduct(name, own);
      delete own.product_id;
      delete own.variant_id;
      const payload = Object.assign(
        {
          event_id: uuid(),
          ts: new Date().toISOString(),
          page_type: pageContext.pageType || null,
          template: pageContext.template || null
        },
        about,
        {
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || pageContext.currency || null,
          theme_id: (window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || null,
          release: RELEASE
        },
        own
      );
      if (isInternal()) payload.traffic_type = 'internal';
      const exp = expNow();
      if (exp) payload.exp = exp;
      payload.consent = consentNow();
      if (top && typeof top.em === 'string' && /^[0-9a-f]{64}$/.test(top.em)) payload.em = top.em;

      Object.assign(payload, { ev: entry.ev, tv: TAXONOMY_VERSION, layer: entry.layer, page_view_id: pageViewId }, stamp || stampChain(entry, at));

      recent.push({ name, payload });
      if (recent.length > RECENT_MAX) recent.shift();
      if (debugOn()) console.debug('sofsyTrack', name, payload);

      toBus(name, payload);
      if (beaconWanted(entry, navigates)) toBeacon(name, payload);
      if (entry.clarity) toClarity(['event', name]);
      if (has(RESOLVES, name)) endPerf(RESOLVES[name], own.source ? { source: own.source } : null);
      return payload.event_id;
    } catch (_) {
      return null;
    }
  }

  /* ---------- perf.*: tap -> visible result ---------- */
  const PERF_WAIT_MS = 10000;
  const pendingPerf = {}; // result key -> {at, from}

  const afterPaint = (fn) => {
    try {
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(() => window.requestAnimationFrame(fn));
        return;
      }
    } catch (_) {
      /* fall through */
    }
    setTimeout(fn, 0);
  };

  // One timer at a time: a newer timed tap replaces any older one, whose result never came (a tap that did
  // nothing, a write that failed silently), so a stale timer cannot be ended by an unrelated result.
  function startPerf(name, at) {
    const key = has(TAXONOMY, name) ? TAXONOMY[name].perf : null;
    if (!key) return;
    Object.keys(pendingPerf).forEach((k) => delete pendingPerf[k]);
    pendingPerf[key] = { at, from: name };
  }

  // `now`: the result is already on screen (the page is going away), so no wait for a paint.
  // `hold` (zao#617): measured now, sent later: hold(send) gets the send function, send(more) adds more props.
  function endPerf(key, extra, now, hold) {
    try {
      const started = pendingPerf[key];
      if (!started) return;
      delete pendingPerf[key];
      if (nowMs() - started.at > PERF_WAIT_MS) return;
      const done = () => {
        const ms = Math.max(0, Math.round(nowMs() - started.at));
        measure(`sofsy:${PERF_EVENTS[key]}`, `sofsy:tap:${started.from}`);
        const send = (more) => emit(PERF_EVENTS[key], Object.assign({ ms, from: started.from }, extra || {}, more || {}), null);
        if (typeof hold === 'function') hold(send);
        else send();
      };
      if (now) done();
      else afterPaint(done);
    } catch (_) {
      /* tracking never breaks the page */
    }
  }

  /* ---------- the commerce listeners (assets/cart.js) ---------- */

  const addSource = (raw) => (typeof raw === 'string' && has(ADD_SOURCES, raw) ? ADD_SOURCES[raw] : raw || 'other');

  // Lines of a bag state / cart / add answer for one variant: quantity held and the unit price after the Privilege
  // (final_line_price / quantity: Shopify's own figure, never a recomputed discount).
  const variantLines = (lines, variantId) =>
    Array.isArray(lines) ? lines.filter((line) => Number(line.variant_id) === variantId) : [];
  const heldIn = (state, variantId) =>
    variantLines(state && (state.lines || state.items), variantId).reduce((sum, line) => sum + (Number(line.quantity) || 0), 0);
  const unitFinal = (lines) => {
    const quantity = lines.reduce((sum, line) => sum + (Number(line.quantity) || 0), 0);
    const total = lines.reduce((sum, line) => sum + (Number(line.final_line_price) || 0), 0);
    return quantity > 0 ? total / quantity : null;
  };

  // What one add put in the bag, per variant, in the order she asked for them: [{variant_id, product_id, quantity,
  // unit}] where unit is the line's price after the Privilege in cents (from the bag as the add's own answer rendered
  // it; else from the add answer's lines). `quantities` overrides the asked quantities (a partial add).
  function linesAdded(detail, quantities) {
    const asked = Array.isArray(detail.items) ? detail.items : [];
    const after = detail.after && Array.isArray(detail.after.lines) ? detail.after.lines : null;
    const answer = detail.response && Array.isArray(detail.response.items) ? detail.response.items : null;
    const out = [];
    asked.forEach((item) => {
      const variant = positiveId(item && item.id);
      if (!variant) return;
      const quantity = quantities ? quantities.get(variant) || 0 : Number(item.quantity) || 0;
      if (quantity <= 0) return;
      const fromBag = after ? variantLines(after, variant) : [];
      const fromAnswer = answer ? variantLines(answer, variant) : [];
      const source = fromBag.length ? fromBag : fromAnswer;
      const line = source[0] || null;
      out.push({
        variant_id: variant,
        product_id: line ? positiveId(line.product_id) : null,
        quantity,
        unit: unitFinal(source),
        key: (fromAnswer[0] && fromAnswer[0].key) || (line && line.key) || null
      });
    });
    return out;
  }

  function addedProps(source, added, partial, currency) {
    const units = added.reduce((sum, line) => sum + line.quantity, 0);
    const known = added.every((line) => line.unit !== null);
    const props = {
      source,
      lines: added.length,
      units,
      // major units, after the Privilege, no tax or shipping: price after the Privilege x quantity actually added
      value: known ? Math.round(added.reduce((sum, line) => sum + line.unit * line.quantity, 0)) / 100 : null,
      currency,
      partial: !!partial
    };
    if (added.length === 1) {
      if (added[0].product_id) props.product_id = added[0].product_id;
      props.variant_id = added[0].variant_id;
    }
    return props;
  }

  const currencyOf = (state) =>
    (state && state.currency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null;

  // US only (the threshold is US-only), compared before and after each write on the cart's total_price, which is
  // after the Privilege (KD-40). Both figures come from the bag state, which every write re-renders.
  function thresholdCheck(before, after) {
    try {
      if (!before || !after || after.is_us !== true) return;
      const threshold = cents(after.threshold);
      const was = cents(before.total_price);
      const now = cents(after.total_price);
      if (!(threshold > 0) || was === null || now === null) return;
      let direction = null;
      if (was < threshold && now >= threshold) direction = 'up';
      else if (was >= threshold && now < threshold) direction = 'down';
      if (!direction) return;
      sofsyTrack('shipping_threshold_crossed', {
        direction,
        threshold: threshold / 100,
        value: now / 100,
        currency: currencyOf(after)
      });
    } catch (_) {
      /* tracking never breaks the page */
    }
  }

  // 422 sentences are Shopify's (English store); the rest is from the answer's status and the network.
  function failReason(detail) {
    if (detail.rateLimited || detail.status === 429) return 'rate_limited';
    if (detail.network) return 'network';
    if (detail.status === 422) {
      const words = String(detail.description || '').toLowerCase();
      if (/sold out/.test(words)) return 'sold_out';
      if (/\bonly \d+|availability|can't add more|cannot add more|can only add|maximum|not enough/.test(words)) return 'stock_limit';
    }
    return 'other';
  }

  function onAdded(detail) {
    const source = addSource(detail.source);
    const added = linesAdded(detail, null);
    if (!added.length) return;
    const currency = currencyOf(detail.after || detail.before);
    sofsyTrack('bag_items_added', addedProps(source, added, false, currency));
    // The quiet first half of a colour or size change renders nothing; its second half (sofsy:cart-updated) compares
    // the bag before the change with the bag after it.
    if (!detail.quiet) thresholdCheck(detail.before, detail.after);
    if (!NO_KLAVIYO.has(source)) klaviyoAddedToCart(detail, added);
  }

  function onAddFailed(detail) {
    const source = addSource(detail.source);
    // Shopify adds what stock allows and still answers 422 ("Only 20 items were added …"). The units it kept are the
    // difference between the bag before the add and the bag after the reconcile. A colour or size change takes them
    // back off again (rolledBack), so nothing was added there.
    const quantities = new Map();
    if (detail.before && detail.after && !detail.rolledBack) {
      (Array.isArray(detail.items) ? detail.items : []).forEach((item) => {
        const variant = positiveId(item && item.id);
        if (!variant) return;
        const more = heldIn(detail.after, variant) - heldIn(detail.before, variant);
        if (more > 0) quantities.set(variant, Math.min(more, Number(item.quantity) || more));
      });
    }
    const kept = quantities.size > 0;
    const partial = typeof detail.partial === 'boolean' ? detail.partial : kept;
    sofsyTrack('bag_add_failed', { source, reason: failReason(detail), partial: !!partial });
    if (kept) {
      const added = linesAdded(detail, quantities);
      if (added.length) sofsyTrack('bag_items_added', addedProps(source, added, true, currencyOf(detail.after)));
      thresholdCheck(detail.before, detail.after);
      // A partly kept add sends ONE Klaviyo "Added to Cart", built from the kept quantities only (dictionary v1.4
      // section 3.2; the tracking gate's change to step 8). The bag did change, and the deleted wrapper fired on every
      // /cart/add.js answer, 422s included. Without it, a shopper whose only add was stock-limited has units in the
      // bag but never reaches Cart Abandon (Sx4yCT): Shopify sends no product_added_to_cart for a 422.
      // Its top-level fields describe the first line she asked for that Shopify kept. Not for bag_swap / bag_undo.
      if (added.length && !NO_KLAVIYO.has(source)) klaviyoAddedToCart(detail, added);
    }
    // A full refusal (nothing kept) sends no Klaviyo event, and nor does a colour or size change whose add half was
    // taken back off again (rolledBack, so `kept` is false).
  }

  function onUpdated(detail) {
    thresholdCheck(detail.before, detail.after);
  }

  function bagFigures(state) {
    const lines = state && Array.isArray(state.lines) ? state.lines : [];
    const total = state ? cents(state.total_price) : null;
    return {
      lines: lines.length,
      units: state && Number.isSafeInteger(state.item_count) ? state.item_count : lines.reduce((s, l) => s + (Number(l.quantity) || 0), 0),
      value: total === null ? null : total / 100,
      currency: currencyOf(state)
    };
  }

  // zao#617: after a quantity drawer add the bag now opens at once, while /cart/add.js is still on its way
  // ('sofsy:bag-opened' pending:true). perf.bag.open is MEASURED at that open (the bag is on screen); it and view_cart
  // are SENT when the add has been answered ('sofsy:bag-add-settled'), so view_cart's lines, units and free-shipping
  // figures describe the bag as the add left it, exactly as before, and both carry add_failed:true when Shopify
  // refused the add outright (ok:false, cartChanged not true): a bag opened for a refused add is not a real bag view.
  // Sent untagged if the bag closes first (or the page has not heard back after PERF_WAIT_MS).
  let heldViewCart = null; // {source, timer, more: props once known, perfSend: perf.bag.open's send once measured}

  function sendHeldViewCart(detail) {
    const held = heldViewCart;
    if (!held) return;
    heldViewCart = null;
    clearTimeout(held.timer);
    held.more = detail && detail.ok === false && detail.cartChanged !== true ? { add_failed: true } : {};
    if (held.perfSend) held.perfSend(held.more);
    sendViewCart(held.source, held.more);
  }

  function onBagOpened(detail) {
    const source = (detail && detail.source) || 'add';
    sendHeldViewCart(null); // a previous open's, never left behind
    if (detail && detail.pending) {
      const held = { source, timer: setTimeout(() => sendHeldViewCart(null), PERF_WAIT_MS), more: null, perfSend: null };
      heldViewCart = held;
      endPerf('bag_open', { source }, false, (send) => {
        if (held.more) send(held.more); // the answer came before the paint
        else held.perfSend = send;
      });
      return;
    }
    sendViewCart(source, null);
  }

  function sendViewCart(source, more) {
    const state = bagState();
    const figures = bagFigures(state);
    const threshold = state && state.is_us === true ? cents(state.threshold) : null;
    const total = state ? cents(state.total_price) : null;
    const known = threshold > 0 && total !== null;
    sofsyTrack(
      'view_cart',
      Object.assign(
        { source },
        figures,
        {
          free_shipping_remaining: known ? Math.max(0, threshold - total) / 100 : null,
          free_shipping_reached: known ? total >= threshold : null
        },
        more || {}
      )
    );
  }

  function onCheckout() {
    sofsyTrack('checkout_clicked', bagFigures(bagState()));
  }

  /* ---------- sink 3: Klaviyo "Added to Cart" (UsSsZt) ---------- */

  // The amounts Klaviyo's own `item` (its viewed_product script) holds, e.g. Price "65": the shop shows whole
  // currency units; a price with cents keeps them.
  const klaviyoAmount = (value) => {
    const c = cents(value);
    if (c === null) return '0';
    return c % 100 === 0 ? String(c / 100) : (c / 100).toFixed(2);
  };

  const shopOrigin = () => {
    try {
      return window.location.origin;
    } catch (_) {
      return '';
    }
  };

  const readCart = () =>
    fetch(`${(window.routes && window.routes.cart_url) || '/cart'}.js`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    }).then((response) => {
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.json().then((cart) => {
        if (!cart || !Array.isArray(cart.items)) throw new Error('not a cart');
        return cart;
      });
    });

  const later = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // The /cart.js the add produced (the old tracker read it the same way, after the add). One retry; without a cart
  // the event still goes, from the bag state and the add's own answer, so the flow is not lost to a slow read.
  const cartAfterAdd = () =>
    readCart().catch(() =>
      later(CART_RETRY_MS)
        .then(readCart)
        .catch(() => null)
    );

  function klaviyoAddedToCart(detail, added) {
    const ts = Date.now();
    // The FIRST line added describes the event at the top level (Name, Price, ProductID, …); items[] carries every
    // line in the bag. On an add of several lines that is the first one she asked for (her own shade from Add to Bag,
    // the first set shade from Complete the Set); on a partly kept add, the first one she asked for that Shopify kept.
    const first = added[0];
    cartAfterAdd().then((cart) => {
      try {
        const state = bagState() || detail.after || null;
        const cartLines = cart ? cart.items : null;
        const firstLine =
          (cartLines && variantLines(cartLines, first.variant_id)[0]) ||
          (detail.response && Array.isArray(detail.response.items) ? variantLines(detail.response.items, first.variant_id)[0] : null) ||
          null;
        const productId = first.product_id || (firstLine && positiveId(firstLine.product_id)) || null;
        // The product's fields exactly as Klaviyo's viewed_product item has them (snippets/bag-state-json.liquid
        // "products"): title, collection titles, the featured image at grande on the shop's domain, the product URL on
        // the shop's primary domain, vendor, price and compare-at price. Rendered by the same answer as the add.
        const info = (state && state.products && productId && state.products[String(productId)]) || null;
        const image = firstLine ? (firstLine.featured_image && firstLine.featured_image.url) || firstLine.image || '' : '';
        const handle = firstLine && firstLine.handle ? firstLine.handle : '';
        const totals = cart || state || {};

        const keys = (cartLines ? added.map((line) => (variantLines(cartLines, line.variant_id)[0] || {}).key) : added.map((line) => line.key)).filter(Boolean);
        const token = cart && typeof cart.token === 'string' ? cart.token.split('?')[0] : 'no-token'; // never the ?key= secret

        // Same keys, in the same order and units, as the old wrapper (templates/product.json custom_liquid_hH3PnT):
        // the cart's totals in major units except total_discount (cents, as it sent it), items[] = /cart.js lines
        // after the add, then the product fields of Klaviyo's item.
        const payload = {
          total_price: major(totals.total_price),
          $value: major(totals.total_price),
          total_discount: cents(totals.total_discount),
          original_total_price: major(totals.original_total_price),
          items: cartLines || (detail.response && Array.isArray(detail.response.items) ? detail.response.items : []),
          Name: info ? info.title : (firstLine && firstLine.product_title) || '',
          ProductID: productId,
          Categories: info && Array.isArray(info.categories) ? info.categories : [],
          ImageURL: info && info.image ? info.image : image,
          URL: info && info.url ? info.url : handle ? `${shopOrigin()}/products/${handle}` : '',
          Brand: info ? info.vendor : (firstLine && firstLine.vendor) || '',
          Price: klaviyoAmount(info ? info.price : firstLine && firstLine.original_price),
          Value: klaviyoAmount(info ? info.price : firstLine && firstLine.original_price),
          CompareAtPrice: klaviyoAmount(info ? info.compare_at_price_max : 0),
          $event_id: `${token}:${keys.join(',')}:${ts}`,
          StorefrontCart: true
        };
        if (isInternal()) payload.Internal = true;

        window._learnq = window._learnq || [];
        window._learnq.push(['track', KLAVIYO_METRIC, payload]);
        recent.push({ name: `klaviyo:${KLAVIYO_METRIC}`, payload: { $event_id: payload.$event_id, ProductID: payload.ProductID } });
        if (recent.length > RECENT_MAX) recent.shift();
        if (debugOn()) console.debug('sofsyTrack klaviyo', KLAVIYO_METRIC, payload);
      } catch (_) {
        /* tracking never breaks the page */
      }
    });
  }

  const listen = (type, handler) =>
    document.addEventListener(type, (event) => {
      try {
        handler((event && event.detail) || {});
      } catch (_) {
        /* tracking never breaks the page */
      }
    });

  listen('sofsy:cart-added', onAdded);
  listen('sofsy:cart-add-failed', onAddFailed);
  listen('sofsy:cart-updated', onUpdated);
  listen('sofsy:bag-opened', onBagOpened);
  listen('sofsy:bag-add-settled', (detail) => sendHeldViewCart(detail));
  listen('sofsy:bag-closed', () => sendHeldViewCart(null)); // before bag.js's bag_closed: this file loads first
  listen('sofsy:bag-checkout', onCheckout);
  // A bag write that finished re-rendered the bag: the end of a stepper, swap, remove, Undo or set tap's timer.
  // The quiet first half of a colour or size change renders nothing: its timer ends at the second half.
  ['sofsy:cart-added', 'sofsy:cart-add-failed', 'sofsy:cart-updated'].forEach((type) =>
    listen(type, (detail) => {
      if (!detail.quiet) endPerf('bag_update');
    })
  );

  /* ---------- the tap layer: one delegated listener for every data-sofsy-track element ----------
   * Capture phase on the document, so a component's stopPropagation cannot hide a tap. The event is built one tick
   * later, after the component's own handlers ran, so it reads the state the tap left (aria-checked, a <details>
   * opened, a checkbox ticked); t_ms is still the moment of the tap.
   * Read from the element: data-sofsy-track (the name), data-sofsy-track-value (colour or size name, image index,
   * quantity, a menu handle), data-sofsy-track-id or a plain id; the variant / product / shade of the closest
   * ancestor that names one (data-sofsy-track-variant or data-variant-id, data-sofsy-track-product or
   * data-product-id, data-sofsy-track-shade or data-shade-name); for a link, the kind of page it goes to; for a radio, checkbox or <select>
   * the theme tagged, its value. Never the text of anything, never what she typed (text, email, phone and search fields send the tap
   * only). A <label> and the input it clicks for her count once (within 80 ms). */
  const TAP_ATTR = 'data-sofsy-track';
  const TAP_DEDUPE_MS = 80;
  const NAV_MAX_MS = 30000;
  // Elements other scripts build (no Liquid to tag): the gallery's Splide controls, the Reviews.io widget, the consent
  // banner and Klaviyo forms. First match wins.
  const AUTO = [
    ['.product-gallery .splide__arrow--prev', 'pdp.gallery.prev.tap'],
    ['.product-gallery .splide__arrow--next', 'pdp.gallery.next.tap'],
    ['.product-gallery .splide__pagination__page', 'pdp.gallery.dot.tap'],
    ['.product-gallery .splide__slide', 'pdp.gallery.image.tap'],
    ['[data-reviews-io] a, [data-reviews-io] button, [data-reviews-io] [role="button"], [data-reviews-io] [role="tab"]', 'pdp.reviews.widget.tap'],
    ['#onetrust-consent-sdk button, #onetrust-consent-sdk a', 'popup.consent.tap'],
    ['.klaviyo-form button, .klaviyo-form a, .klaviyo-form input', 'popup.klaviyo_form.tap']
  ];
  const INTERACTIVE =
    'a[href], button, select, textarea, summary, input:not([type="hidden"]), [role="button"], [role="link"], [role="radio"], [role="tab"], [role="checkbox"], [role="switch"], [role="menuitem"], [role="option"], [onclick]';
  const SAFE_ID = /^[A-Za-z0-9_:.-]{1,80}$/;
  const lastTap = { el: null, at: -1e9 };
  // The same tap seen twice: the element itself again, or a <label> and the input it clicks for her.
  const sameTap = (a, b) => !!a && !!b && (a === b || a.control === b || b.control === a);

  // The tagged element a tap belongs to: [element, name], or null.
  function taggedOf(target) {
    if (!target || typeof target.closest !== 'function') return null;
    const own = target.closest(`[${TAP_ATTR}]`);
    if (own) return [own, own.getAttribute(TAP_ATTR), true];
    for (let i = 0; i < AUTO.length; i += 1) {
      const hit = target.closest(AUTO[i][0]);
      if (hit) return [hit, AUTO[i][1]];
    }
    const other = target.closest(INTERACTIVE);
    return other ? [other, 'page.other.tap'] : null;
  }

  // The kind of page a link goes to, from its path only (never the address itself).
  function linkKind(el) {
    try {
      const raw = el.getAttribute('href');
      if (!raw || raw === '#' || /^javascript:/i.test(raw)) return 'none';
      if (raw.charAt(0) === '#') return 'anchor';
      if (/^(mailto|tel):/i.test(raw)) return raw.slice(0, raw.indexOf(':')).toLowerCase();
      const url = new URL(raw, window.location.href);
      if (url.origin !== window.location.origin) return 'external';
      const path = url.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, ''); // a market's language prefix
      if (path === '/' || path === '') return 'home';
      const kind = /^\/(collections|products|pages|blogs|cart|account|search|policies)\b/.exec(path);
      return kind ? kind[1] : 'other';
    } catch (_) {
      return 'other';
    }
  }

  const sameOriginLink = (el) => {
    try {
      if (!el || el.tagName !== 'A' || !el.getAttribute('href') || /^(#|javascript:|mailto:|tel:)/i.test(el.getAttribute('href'))) return false;
      return new URL(el.getAttribute('href'), window.location.href).origin === window.location.origin;
    } catch (_) {
      return false;
    }
  };

  // A link to this same page that only adds or changes a #fragment: it scrolls, nothing unloads.
  const samePageAnchor = (el) => {
    try {
      const url = new URL(el.getAttribute('href'), window.location.href);
      return !!url.hash && url.href.split('#')[0] === String(window.location.href).split('#')[0];
    } catch (_) {
      return false;
    }
  };

  // `own`: the element carries the theme's own data-sofsy-track. Only then are its value and checked state read: a
  // field the theme did not tag (another app's form, an address form) sends the tap and nothing it holds.
  function tapProps(el, event, name, own) {
    const props = {};
    const id = el.getAttribute('data-sofsy-track-id') || el.id;
    if (id && SAFE_ID.test(id)) props.el = id;
    const control = el.tagName === 'LABEL' && el.control ? el.control : el;
    const type = control.tagName === 'INPUT' ? String(control.type || '').toLowerCase() : '';
    const given = own ? el.getAttribute('data-sofsy-track-value') : null;
    if (!own) {
      /* no value from a field the theme did not tag */
    } else if (given) props.value = given.slice(0, 64);
    else if (control.tagName === 'SELECT' && control.selectedIndex >= 0) props.value = String(control.value || '').slice(0, 64);
    else if (type === 'radio' || type === 'checkbox' || type === 'number') props.value = String(control.value || '').slice(0, 64);
    if (own && (type === 'radio' || type === 'checkbox')) props.checked = !!control.checked;
    const state =
      el.tagName === 'SUMMARY' && el.parentElement && el.parentElement.tagName === 'DETAILS'
        ? el.parentElement.open
          ? 'open'
          : 'closed'
        : el.getAttribute('aria-expanded') || el.getAttribute('aria-checked') || el.getAttribute('aria-selected');
    if (state) props.state = state;
    if (el.disabled || el.getAttribute('aria-disabled') === 'true' || control.disabled) props.disabled = true;
    const variant = el.closest('[data-sofsy-track-variant], [data-variant-id]');
    if (variant) {
      const v = positiveId(variant.getAttribute('data-sofsy-track-variant') || variant.getAttribute('data-variant-id'));
      if (v) props.variant_id = v;
    }
    const product = el.closest('[data-sofsy-track-product], [data-product-id]');
    if (product) {
      const p = positiveId(product.getAttribute('data-sofsy-track-product') || product.getAttribute('data-product-id'));
      if (p) props.product_id = p;
    }
    const shade = el.closest('[data-sofsy-track-shade], [data-shade-name]');
    const shadeName = shade && (shade.getAttribute('data-sofsy-track-shade') || shade.getAttribute('data-shade-name'));
    if (shadeName) props.shade = shadeName.slice(0, 64);
    if (el.tagName === 'A') props.link = linkKind(el);
    // 1-based position among the elements with the same name in its list (a menu, a row of pills, the bag's lines)
    const list = el.parentElement && el.parentElement.closest('ul, ol, nav, fieldset, [role="list"], [role="radiogroup"], [role="tablist"], [data-sofsy-track-list]');
    if (list && name !== 'page.other.tap') {
      const same = Array.prototype.filter.call(list.querySelectorAll(`[${TAP_ATTR}]`), (node) => node.getAttribute(TAP_ATTR) === name);
      const index = same.indexOf(el);
      if (index >= 0 && same.length > 1) props.pos = index + 1;
    }
    if (name === 'page.other.tap') props.tag = el.tagName.toLowerCase();
    props.input = event && event.detail === 0 ? 'keyboard' : (event && event.pointerType) || 'pointer';
    return props;
  }

  function onTap(event) {
    try {
      const hit = taggedOf(event.target);
      if (!hit) return;
      const [el, name, own] = hit;
      if (el.tagName === 'SELECT') return; // a <select> reports its change
      const entry = resolve(name);
      if (!entry) return;
      const at = nowMs();
      if (at - lastTap.at < TAP_DEDUPE_MS && sameTap(el, lastTap.el)) return;
      lastTap.el = el;
      lastTap.at = at;
      mark(`sofsy:tap:${name}`);
      // A tap that cannot do anything (disabled) starts no timer: no result would end it.
      if (!el.disabled && el.getAttribute('aria-disabled') !== 'true') startPerf(name, at);
      const stamp = stampChain(entry, at); // its place now, before the result its handler sends
      const wall = Date.now();
      setTimeout(() => {
        try {
          // A link that will load the next page: not stopped by a handler, same tab, no modifier key.
          const navigates =
            sameOriginLink(el) &&
            !samePageAnchor(el) &&
            !event.defaultPrevented &&
            !/^_blank$/i.test(el.getAttribute('target') || '') &&
            !(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey);
          if (navigates) writeSession(NAV_KEY, { from: name, at: wall });
          emit(name, tapProps(el, event, name, own), at, stamp, navigates);
        } catch (_) {
          /* tracking never breaks the page */
        }
      }, 0);
    } catch (_) {
      /* tracking never breaks the page */
    }
  }

  function onChange(event) {
    try {
      const target = event.target;
      if (!target || target.tagName !== 'SELECT') return;
      const hit = taggedOf(target);
      if (!hit || hit[0] !== target) return;
      emit(hit[1], tapProps(target, event, hit[1], hit[2]), nowMs());
    } catch (_) {
      /* tracking never breaks the page */
    }
  }

  // Interactive elements on this page with no name (console: SofsyTrack.untagged()). The crawler's live twin: run on
  // a preview to see what the static crawl cannot (markup that scripts build).
  function untagged() {
    try {
      return Array.prototype.filter
        .call(document.querySelectorAll(INTERACTIVE), (el) => {
          const hit = taggedOf(el);
          return !hit || hit[1] === 'page.other.tap';
        })
        .map((el) => `${el.tagName.toLowerCase()}${el.id ? `#${el.id}` : ''}${el.className && typeof el.className === 'string' ? `.${el.className.trim().split(/\s+/).join('.')}` : ''}`);
    } catch (_) {
      return [];
    }
  }

  /* ---------- the gallery: slide_view with dwell and how she moved (swipe, arrow, thumb, wheel, key) ----------
   * The gallery is Splide inside assets/bundle.js, which is not edited: the active slide (.splide__slide.is-active) is
   * watched, and the move is put down to the input that came within 1 s before it. Clones are not counted. A rebuilt
   * slide list (a skin change, a remount) starts again silently. At most 60 slide_view per page view; on each hide,
   * pdp.gallery.summary holds the totals and the dwell on the slide she was on. */
  const GALLERY_MAX = 60;
  function watchGallery() {
    const root = document.querySelector('.product-gallery');
    if (!root || typeof MutationObserver !== 'function') return;
    const g = { el: null, index: 0, since: 0, views: 0, seen: new Set(), method: null, methodAt: -1e9 };
    const layout = () => (window.innerWidth >= 989 ? 'desktop' : 'mobile');
    const slides = () => Array.prototype.filter.call(root.querySelectorAll('.splide__slide'), (s) => !s.classList.contains('splide__slide--clone'));
    const input = (method) => {
      g.method = method;
      g.methodAt = nowMs();
    };
    let start = null;
    root.addEventListener(
      'pointerdown',
      (e) => {
        start = { x: e.clientX, y: e.clientY, touch: e.pointerType !== 'mouse' };
      },
      { passive: true }
    );
    root.addEventListener(
      'pointerup',
      (e) => {
        if (start && (Math.abs(e.clientX - start.x) > 10 || Math.abs(e.clientY - start.y) > 10)) input(start.touch ? 'swipe' : 'drag');
        start = null;
      },
      { passive: true }
    );
    root.addEventListener('pointercancel', () => start && input(start.touch ? 'swipe' : 'drag'), { passive: true });
    root.addEventListener('wheel', () => input('wheel'), { passive: true });
    root.addEventListener('keydown', (e) => /^Arrow/.test(e.key) && input('key'));
    document.addEventListener(
      'click',
      (e) => {
        const t = e.target;
        if (!t || typeof t.closest !== 'function') return;
        if (t.closest('.product-gallery .splide__arrow')) input('arrow');
        else if (t.closest('.product-gallery .splide__pagination')) input('dot');
        else if (t.closest('.thumbnail-list, .thumbnail-slider, .thumbnail-vertical-slider')) input('thumb');
      },
      true
    );
    window.addEventListener('thumbnailClicked', () => input('thumb'));

    const sync = () => {
      try {
        const now = nowMs();
        const list = slides();
        const el = list.find((s) => s.classList.contains('is-active')) || null;
        if (!el || el === g.el) return;
        const index = list.indexOf(el) + 1;
        if (!g.el || !g.el.isConnected) {
          // first sight, or the list was rebuilt: no move to report
          g.el = el;
          g.index = index;
          g.since = now;
          g.seen.add(index);
          return;
        }
        const dwell = Math.round(now - g.since);
        const method = now - g.methodAt < 1000 ? g.method : 'other';
        g.views += 1;
        g.seen.add(index);
        if (g.views <= GALLERY_MAX) {
          emit(
            'pdp.gallery.slide_view',
            { index, total: list.length, from: g.index, direction: index > g.index ? 'next' : 'prev', method, dwell_ms_prev: dwell, layout: layout() },
            now
          );
        }
        endPerf('slide', { index, method });
        g.el = el;
        g.index = index;
        g.since = now;
      } catch (_) {
        /* tracking never breaks the page */
      }
    };
    new MutationObserver(sync).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    sync();
    onHide(() => {
      if (!g.el) return;
      emit('pdp.gallery.summary', {
        views: g.views,
        slides_seen: g.seen.size,
        total: slides().length,
        last_index: g.index,
        last_dwell_ms: Math.round(nowMs() - g.since),
        layout: layout()
      });
    });
  }

  /* ---------- the page: scroll depth, exit (engaged time), script errors, the tap that brought her here ---------- */
  const hideHandlers = [];
  function onHide(fn) {
    hideHandlers.push(fn);
  }
  const SCROLL_MARKS = [25, 50, 75, 90];
  const ERROR_MAX = 5; // page.error.js events per page view, every kind together (zao#617)
  const ERROR_MUTED_MAX = 1; // muted cross-origin errors per page ("Script error." with no file), inside ERROR_MAX
  const ERROR_FILES = ['bundle.js', 'global.js', 'cart.js', 'bag.js', 'qty-drawer.js', 'sofsy-pdp.js', 'sofsy-track.js', 'notify-me.js', 'predictive-search.js', 'clarity-tagging.js', 'custom.js'];
  // page.error.js `where` for a script that is not one of ERROR_FILES (zao audit 2026-10-04 F-11, N-07): a closed list
  // of host classes, from the script's address only (never the error's message, line or stack). The hosts are the ones
  // the 4 Oct probe saw on sofsy.com (audit §A). A script inside a Shopify app embed (cdn.shopify.com/extensions/… or
  // this host's /cdn/shop/extensions/…) is named by the app's word in its path; any other theme asset is 'theme';
  // anything else is 'other'. Most third-party scripts load without CORS, so their errors arrive muted (no file at
  // all, kind 'muted') and the host classes stay sparse; pixels Shopify sandboxes (Meta, Google, Pinterest web pixels)
  // never reach this page. Same list as zao worker.js PAGE_ERROR_HOSTS (with 'theme' and 'other').
  const ERROR_HOSTS = [
    ['klaviyo', /(^|\.)klaviyo\.com$/],
    ['gorgias', /(^|\.)(gorgias\.chat|gorgias\.io|gorgias\.com|gorgias-convert\.com|9gtb\.com)$/],
    ['shoplift', /(^|\.)shoplift\.ai$/],
    ['consentmo', /(^|\.)consentmo\.com$/],
    ['pinterest', /(^|\.)(pinterest\.com|pinimg\.com)$/],
    ['meta', /(^|\.)(facebook\.net|facebook\.com|fbcdn\.net)$/],
    ['google', /(^|\.)(googletagmanager\.com|google-analytics\.com|googleadservices\.com|googlesyndication\.com|doubleclick\.net|gstatic\.com|google\.com)$/],
    ['shopify', /(^|\.)(shopify\.com|shopifycdn\.net|shopifysvc\.com|shopifycloud\.com|shop\.app|myshopify\.com)$/]
  ];
  const ERROR_APPS = ['klaviyo', 'gorgias', 'shoplift', 'consentmo', 'pinterest'];
  const ownHost = (host) => host === window.location.hostname || host === 'sofsy.com' || /\.sofsy\.com$/.test(host);
  // The class of the script an error came from: one of ERROR_FILES, a host class, 'theme' or 'other'.
  function errorWhere(filename) {
    let url = null;
    try {
      url = new URL(String(filename), window.location.href);
    } catch (_) {
      return 'other';
    }
    const path = url.pathname.toLowerCase();
    const host = url.hostname.toLowerCase();
    // A theme asset (this host's /cdn/shop/t/<n>/assets/ or Shopify's CDN /t/<n>/assets/): its own file name when it is
    // on the list. Only there: a browser extension's or another site's bundle.js is not the theme's.
    if (/\/t\/\d+\/assets\//.test(path) && (ownHost(host) || host === 'cdn.shopify.com')) {
      const file = url.pathname.split('/').pop();
      const base = file.replace(/\.(min\.)?js$/, '.js').replace(/-[0-9a-f]{8,}\.js$/, '.js');
      return ERROR_FILES.indexOf(base) >= 0 ? base : 'theme';
    }
    const appEmbed = (host === 'cdn.shopify.com' && path.indexOf('/extensions/') === 0) || (ownHost(host) && path.indexOf('/cdn/shop/extensions/') === 0);
    if (appEmbed) {
      const app = ERROR_APPS.find((word) => path.indexOf(word) >= 0);
      return app || 'other';
    }
    if (ownHost(host)) return /^\/(cdn\/shopifycloud|cdn\/wpm|checkouts)\//.test(path) ? 'shopify' : 'other';
    const hit = ERROR_HOSTS.find(([, re]) => re.test(host));
    return hit ? hit[0] : 'other';
  }
  // page.error.js `platform`: ios | android | desktop | other, from the browser's own platform hint where it has one
  // (navigator.userAgentData, Chromium), else a three-way user-agent test. Only the class leaves the page.
  function platformClass() {
    try {
      const nav = window.navigator;
      if (!nav) return 'other';
      const hint = nav.userAgentData && typeof nav.userAgentData.platform === 'string' ? nav.userAgentData.platform.toLowerCase() : '';
      if (hint === 'android') return 'android';
      if (hint === 'ios') return 'ios';
      if (['windows', 'macos', 'linux', 'chrome os', 'chromium os'].indexOf(hint) >= 0) return 'desktop';
      const ua = typeof nav.userAgent === 'string' ? nav.userAgent : '';
      if (!ua) return 'other';
      if (/Android/i.test(ua)) return 'android';
      if (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && nav.maxTouchPoints > 1)) return 'ios'; // iPadOS asks for the desktop site
      // An Android tablet asking for the desktop site says Linux and counts as desktop (not separable from its UA).
      return /Windows|Macintosh|X11|Linux|CrOS/i.test(ua) ? 'desktop' : 'other';
    } catch (_) {
      return 'other';
    }
  }

  // page.error.js `msg` (zao#617, Ben's yes 5 Oct, MC err1; an allowlist since the third privacy audit of storefront
  // #144). The message is BUILT from two parts, never redacted, so no free text from the page ever leaves it:
  //   1. the error type: a leading …Error / …Exception word (ERROR_TYPE_RE, after an optional "Uncaught ") sent only
  //      when it is on ERROR_TYPES (the built-in and DOM names), any other such word as Error (a custom type could
  //      carry a name: JaneDoeError); with no such word, the event's kind (error | muted | rejection);
  //   2. the earliest phrase of ERROR_PHRASES (our own words) found in the message after the type, ignoring case,
  //      sent in our spelling (on a tie the longer phrase);
  //      then up to 3 code paths (ERROR_PATH_RE): a dot-path on one of ERROR_PATH_ROOTS, letters / _ / $ only (no
  //      digits), at most 6 segments and 80 characters, optionally ending in (), standing alone (after a space,
  //      quote, bracket or punctuation; never inside an address); a bare root only when it is a vendor or storage
  //      name (ERROR_BARE_ROOTS: fbq, gtag, klaviyo…), never an English word like "this" or "history";
  // No hash of the message, on purpose: a hash of the raw text can confirm a guessed email. Errors group on msg
  // together with src_host, line and col.
  // Joined with ' | ', at most ERROR_MSG_MAX characters (a path that would pass it is left out). Example:
  // "TypeError | is not an object | window.Shopify.analytics.visitor".
  const ERROR_MSG_MAX = 160;
  const ERROR_SCAN_IN = 1000; // characters searched for a phrase or a path
  const ERROR_TYPE_RE = /^\s*(?:Uncaught\s+(?:\(in promise\)\s+)?)?((?:[A-Za-z]{1,40})?(?:Error|Exception))(?![\w$])/;
  const ERROR_TYPES = [
    'Error', 'TypeError', 'ReferenceError', 'SyntaxError', 'RangeError', 'URIError', 'EvalError', 'AggregateError',
    'InternalError', 'DOMException', 'SecurityError', 'NotAllowedError', 'NotFoundError', 'NotSupportedError',
    'NetworkError', 'AbortError', 'TimeoutError', 'QuotaExceededError', 'InvalidStateError', 'DataCloneError',
    'InvalidAccessError', 'ChunkLoadError'
  ];
  const ERROR_PHRASES = [
    'is not a function', 'is not defined', 'is not an object', 'is not a constructor', 'is not iterable',
    'is not valid JSON', 'is null', 'is undefined', 'is read-only',
    'Cannot read properties of', 'Cannot read property', 'Cannot set properties of', 'Cannot access',
    'before initialization', "Can't find variable", 'Assignment to constant variable', 'has already been declared',
    'Illegal invocation', 'Load failed', 'Failed to fetch', 'Failed to load', 'Failed to execute',
    'NetworkError when attempting to fetch resource', 'Network request failed', 'The network connection was lost',
    'The operation was aborted', 'The user aborted a request', 'The request is not allowed',
    'The operation is insecure', 'The object can not be found here', 'Importing a module script failed',
    'Script error', 'Maximum call stack', 'too much recursion', 'Unexpected token', 'Unexpected identifier',
    'Unexpected end of', 'Invalid or unexpected token', 'JSON Parse error', 'JSON.parse', 'QuotaExceeded',
    'The quota has been exceeded', 'Permission denied', 'Invalid Date', 'out of memory', 'ResizeObserver loop',
    'Non-Error promise rejection', 'Object Not Found Matching Id', 'timed out', 'timeout'
  ];
  const ERROR_PHRASES_LOWER = ERROR_PHRASES.map((p) => p.toLowerCase());
  const ERROR_PATH_ROOTS = [
    'window', 'document', 'this', 'Shopify', 'navigator', 'localStorage', 'sessionStorage', 'self', 'globalThis',
    'history', 'location', 'performance', 'JSON', 'Promise', 'Object', 'Array', 'fetch', 'klaviyo', '_learnq', 'fbq',
    'gtag', 'dataLayer', 'clarity', 'theme', 'sofsy', 'Sofsy'
  ];
  const ERROR_BARE_ROOTS = ['Shopify', 'localStorage', 'sessionStorage', 'globalThis', 'klaviyo', '_learnq', 'fbq', 'gtag', 'dataLayer', 'clarity', 'sofsy', 'Sofsy'];
  const ERROR_PATH_MAX = 80;
  const ERROR_PATHS_MAX = 3;
  // Before a path: the start, whitespace, a quote, an opening bracket or punctuation (never '.', '@', '%', '&', ';',
  // a word character or anything outside ASCII, so a path is never the tail of an address). After it: the end,
  // whitespace, a quote, a closing bracket, punctuation, or a full stop that ends the sentence.
  const ERROR_PATH_RE = new RegExp(
    `(^|[\\s'"\`(\\[{,:=!<>|‘“])((?:${ERROR_PATH_ROOTS.map((r) => r.replace(/\$/g, '\\$')).join('|')})(?:\\.[A-Za-z_$][A-Za-z_$]{0,40}){0,5}(?:\\(\\))?)(?=$|[\\s'"\`)\\]},:!?|<>’”]|\\.(?:\\s|$))`,
    'g'
  );
  function errorMsg(raw, kind) {
    try {
      const text = raw === null || raw === undefined ? '' : String(raw);
      const scan = text.slice(0, ERROR_SCAN_IN);
      const typed = ERROR_TYPE_RE.exec(scan);
      const head = [typed ? (ERROR_TYPES.indexOf(typed[1]) >= 0 ? typed[1] : 'Error') : kind || 'error'];
      const lower = scan.slice(typed ? typed[0].length : 0).toLowerCase();
      let phrase = null;
      let phraseAt = Infinity;
      ERROR_PHRASES_LOWER.forEach((p, i) => {
        const at = lower.indexOf(p);
        if (at >= 0 && (at < phraseAt || (at === phraseAt && p.length > phrase.length))) {
          phrase = ERROR_PHRASES[i];
          phraseAt = at;
        }
      });
      if (phrase) head.push(phrase);
      const paths = [];
      ERROR_PATH_RE.lastIndex = 0;
      let m;
      while (paths.length < ERROR_PATHS_MAX && (m = ERROR_PATH_RE.exec(scan))) {
        const path = m[2];
        const bare = path.replace(/\(\)$/, '').indexOf('.') < 0;
        const ok = path.length <= ERROR_PATH_MAX && (!bare || /\(\)$/.test(path) || ERROR_BARE_ROOTS.indexOf(path) >= 0);
        if (ok && paths.indexOf(path) < 0 && [...head, ...paths, path].join(' | ').length <= ERROR_MSG_MAX) paths.push(path);
        if (m[0].length === 0) ERROR_PATH_RE.lastIndex += 1;
      }
      return [...head, ...paths].join(' | ').slice(0, ERROR_MSG_MAX);
    } catch (_) {
      return null;
    }
  }
  // page.error.js `src_host`: the host name of the script an error came from (cdn.shopify.com, static.klaviyo.com,
  // sofsy.com), never its path or query. A script that is not http(s) gives its scheme instead (webkit-masked-url is
  // Safari's mask for an extension's script; chrome-extension, blob), never the extension's id. An IPv4 host (digits
  // and dots, also after the browser normalises 0x7f000001) is sent as 'ip'; IPv6 ([…]) is null. Null without a file.
  function errorSrcHost(filename) {
    if (!filename) return null;
    try {
      const url = new URL(String(filename), window.location.href);
      const scheme = url.protocol.replace(/:$/, '').toLowerCase();
      if (scheme === 'http' || scheme === 'https') {
        const host = url.hostname.toLowerCase();
        if (/^[\d.]+$/.test(host)) return 'ip';
        return /^[a-z0-9.-]{1,100}$/.test(host) ? host : null;
      }
      return /^[a-z][a-z0-9+.-]{0,31}$/.test(scheme) ? scheme : null;
    } catch (_) {
      return null;
    }
  }
  // An unhandled rejection's reason as text: an Error's "Name: message", a string as it is, anything else only its
  // kind ([object Response], undefined), never its fields.
  function rejectionText(reason) {
    try {
      if (reason && typeof reason === 'object' && typeof reason.message === 'string') {
        const name = typeof reason.name === 'string' && reason.name ? reason.name : 'Error';
        return `${name}: ${reason.message}`;
      }
      if (typeof reason === 'string') return reason;
      if (reason === null || reason === undefined) return String(reason);
      return Object.prototype.toString.call(reason);
    } catch (_) {
      return null;
    }
  }
  const errorLine = (v) => (Number.isInteger(v) && v > 0 && v <= 1e6 ? v : null);

  function watchPage() {
    if (typeof window.addEventListener !== 'function') return;
    const page = { depth: 0, marks: new Set(), visibleSince: nowMs(), engaged: 0, errors: 0, muted: 0, hides: 0, ticking: false };
    const depthNow = () => {
      const doc = document.documentElement;
      const height = Math.max(doc ? doc.scrollHeight : 0, document.body ? document.body.scrollHeight : 0);
      if (!(height > 0)) return 0;
      return Math.min(100, Math.round(((window.scrollY || 0) + (window.innerHeight || 0)) / height * 100));
    };
    const onScroll = () => {
      if (page.ticking) return;
      page.ticking = true;
      afterPaint(() => {
        page.ticking = false;
        const depth = depthNow();
        if (depth > page.depth) page.depth = depth;
        SCROLL_MARKS.forEach((m) => {
          if (depth >= m && !page.marks.has(m)) {
            page.marks.add(m);
            emit('page.scroll.depth', { depth: m });
          }
        });
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    // where (a closed class), kind and platform, plus since zao#617 msg (built from an allowlist: type, phrase and
    // code paths; errorMsg), src_host (a host name only, errorSrcHost) and line / col; never the stack. Per page
    // view: the same msg from the same host, line and col is sent once,
    // and at most ERROR_MAX page.error.js events in all, of which at most ERROR_MUTED_MAX muted.
    const sentErrors = new Set();
    const sendError = (props, muted) => {
      if (page.errors >= ERROR_MAX || (muted && page.muted >= ERROR_MUTED_MAX)) return;
      const key = `${props.msg || ''}|${props.src_host || ''}|${props.line || ''}|${props.col || ''}`;
      if (sentErrors.has(key)) return;
      sentErrors.add(key);
      page.errors += 1;
      if (muted) page.muted += 1;
      Object.keys(props).forEach((k) => props[k] === null && delete props[k]);
      emit('page.error.js', props);
    };
    window.addEventListener('error', (event) => {
      try {
        if (!event) return;
        // A script from another origin without CORS reports "Script error." with no file at all (a muted error, HTML
        // spec): counted as kind 'muted', where 'other', so third-party errors are not silently left out. At most one
        // per page, so a noisy third-party script cannot crowd out the theme's own errors.
        const muted = !event.filename;
        const raw = typeof event.message === 'string' && event.message ? event.message : event.error && event.error.message;
        sendError(
          {
            where: muted ? 'other' : errorWhere(event.filename),
            kind: muted ? 'muted' : 'error',
            platform: platformClass(),
            msg: errorMsg(raw, muted ? 'muted' : 'error'),
            src_host: errorSrcHost(event.filename),
            line: errorLine(event.lineno),
            col: errorLine(event.colno)
          },
          muted
        );
      } catch (_) {
        /* tracking never breaks the page */
      }
    });
    window.addEventListener('unhandledrejection', (event) => {
      try {
        sendError({ where: 'other', kind: 'rejection', platform: platformClass(), msg: errorMsg(rejectionText(event ? event.reason : undefined), 'rejection') }, false);
      } catch (_) {
        /* tracking never breaks the page */
      }
    });

    // One page.exit per hide: from visibilitychange (hidden), or from pagehide where a browser leaves for the next page
    // without a hidden visibilitychange first. `away` stops the second of the two; becoming visible again resets it.
    let away = false;
    const hidden = () => {
      try {
        if (away) return;
        away = true;
        page.hides += 1;
        page.engaged += Math.max(0, nowMs() - page.visibleSince);
        hideHandlers.forEach((fn) => {
          try {
            fn();
          } catch (_) {
            /* the next one still runs */
          }
        });
        emit('page.exit', {
          engaged_s: Math.min(1800, Math.round(page.engaged / 1000)),
          max_depth: Math.max(page.depth, depthNow()),
          events: chain.seq,
          hides: page.hides
        });
      } catch (_) {
        /* tracking never breaks the page */
      }
    };
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') hidden();
      else {
        away = false;
        page.visibleSince = nowMs();
      }
    });
    // Leaving for checkout: the page is going, the navigation has started (Shopify's checkout runs none of this).
    window.addEventListener('pagehide', () => {
      endPerf('checkout', null, true);
      hidden();
    });
    window.addEventListener('pageshow', (event) => {
      if (event && event.persisted) {
        away = false; // back from the back/forward cache: this page view can leave again
        page.visibleSince = nowMs();
      }
    });

    // The tap on the previous page that brought her here: tap -> this page's first paint.
    const nav = readSession(NAV_KEY);
    writeSession(NAV_KEY, null);
    if (nav && typeof nav.from === 'string' && Number.isFinite(nav.at) && Date.now() - nav.at < NAV_MAX_MS) {
      const report = () => {
        try {
          const p = perf();
          const origin = p && Number.isFinite(p.timeOrigin) ? p.timeOrigin : LOADED_AT;
          const paints = p && typeof p.getEntriesByType === 'function' ? p.getEntriesByType('paint') : [];
          const fcp = paints.find((entry) => entry.name === 'first-contentful-paint');
          emit('perf.page.nav', {
            from: nav.from,
            ms: Math.max(0, Math.round(origin + (fcp ? fcp.startTime : nowMs()) - nav.at)),
            nav_ms: Math.max(0, Math.round(origin - nav.at)),
            paint: fcp ? 'fcp' : 'script'
          });
        } catch (_) {
          /* tracking never breaks the page */
        }
      };
      if (document.readyState === 'complete') report();
      else window.addEventListener('load', report, { once: true });
    }
  }

  const domReady = (fn) => {
    const run = () => {
      try {
        fn();
      } catch (_) {
        /* tracking never breaks the page */
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
    else run();
  };

  /* ---------- r6.1 outcome layer: search, collection, reviews, email sign-up, back in stock (email form), 404, login ---
   * Observed from the DOM and from delegated listeners, never by editing assets/bundle.js or the apps' scripts (the
   * gallery's pattern above). Spec sections 3.2-3.14; names in TAXONOMY. Never read here: what she typed (search
   * terms, emails, phone numbers, price amounts), the text of anything, Klaviyo's metaData. Each watcher sends at most
   * what its spec row allows: the dedupe rule is written beside it. */
  const sentOnce = new Set(); // dedupe keys already sent in this page view
  // true the first time `key` is asked in this page view: `first(key) && emit(name, props)`.
  const first = (key) => {
    if (sentOnce.has(key)) return false;
    sentOnce.add(key);
    return true;
  };
  // Catalogue text only (a filter option, a product type): one line, at most `max` characters.
  const catalogue = (value, max) =>
    String(value == null ? '' : value)
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, max);
  const KEY_TOKEN = /^[a-z0-9][a-z0-9_.-]{0,47}$/i; // a theme or Shopify key (sort_by, a handle): never free text
  const token = (value) => (typeof value === 'string' && KEY_TOKEN.test(value) ? value : null);
  const watched = typeof WeakSet === 'function' ? new WeakSet() : new Set();
  const watchOnce = (el) => {
    if (!el || watched.has(el)) return false;
    watched.add(el);
    return true;
  };
  // fn(entry) when `el` is at least `ratio` in view; one observer per element, disconnected after its first sight.
  const inView = (el, ratio, fn) => {
    if (!el || typeof window.IntersectionObserver !== 'function') return;
    const io = new window.IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= ratio) {
            io.disconnect();
            try {
              fn(entry);
            } catch (_) {
              /* tracking never breaks the page */
            }
          }
        });
      },
      { threshold: [ratio] }
    );
    io.observe(el);
  };
  const observe = (el, options, fn) => {
    if (!el || typeof MutationObserver !== 'function') return null;
    const mo = new MutationObserver(() => {
      try {
        fn(mo);
      } catch (_) {
        /* tracking never breaks the page */
      }
    });
    mo.observe(el, options);
    return mo;
  };

  // search.predictive.view {results, zero, place}: the predictive results first render in an open search; once per
  // open of the header's search modal (its <details> closing starts a new open), once per page view for the search
  // page's own field. results = the product results listed (assets/predictive-search.js renders
  // sections/predictive-search.liquid). The query is never read.
  function watchPredictive() {
    Array.prototype.forEach.call(document.querySelectorAll('predictive-search'), (host) => {
      const box = host.querySelector('[data-predictive-search]');
      if (!box || !watchOnce(box)) return;
      const details = typeof host.closest === 'function' ? host.closest('details') : null;
      const state = { shown: false };
      if (details) details.addEventListener('toggle', () => {
        if (!details.open) state.shown = false;
      });
      observe(box, { childList: true }, () => {
        if (state.shown || !box.querySelector('#predictive-search-results')) return;
        state.shown = true;
        const results = box.querySelectorAll('#predictive-search-results-list a.predictive-search__item--link').length;
        emit('search.predictive.view', { results, zero: results === 0, place: details ? 'modal' : 'page' });
      });
    });
  }

  // search.results.view {results, zero_results, sort}: the search template rendered a search; once per page view.
  // From sections/main-search.liquid's data-sofsy-search-results (search.results_count) and -sort (its sort_by key).
  function searchResults() {
    const el = document.querySelector('[data-sofsy-search-results]');
    if (!el) return;
    const results = Math.max(0, Number(el.getAttribute('data-sofsy-search-results')) || 0);
    first('search.results') && emit('search.results.view', { results, zero_results: results === 0, sort: token(el.getAttribute('data-sofsy-search-sort')) || 'relevance' });
  }

  // collection.filter.apply {filter, action, value}: a facet or the product-type nav changes the grid. filter is the
  // kind (from Shopify's filter parameter name or the filter's label), action add / remove / clear, value the option
  // (catalogue text, at most 48 characters), never for price: the shopper types the price range.
  const filterKind = (raw) => {
    const s = String(raw || '').toLowerCase();
    if (/price/.test(s)) return 'price';
    if (/availab/.test(s)) return 'availability';
    if (/size/.test(s)) return 'size';
    if (/colou?r|shade/.test(s)) return 'colour';
    if (/product_type|\btype\b|-type\b/.test(s)) return 'type';
    return 'other';
  };
  const FACET_FORMS = 'facet-filters-form, #FacetFiltersForm, #FacetFiltersFormMobile';
  function filterApplied(filter, action, value) {
    const props = { filter, action };
    if (filter !== 'price' && action !== 'clear' && value) props.value = catalogue(value, 48);
    emit('collection.filter.apply', props);
  }
  function onFacetChange(event) {
    try {
      const input = event.target;
      if (!input || input.tagName !== 'INPUT' || typeof input.closest !== 'function' || !input.closest(FACET_FORMS)) return;
      const name = String(input.getAttribute('name') || '');
      if (!/^filter\./.test(name)) return;
      const filter = filterKind(name);
      if (String(input.type || '').toLowerCase() === 'checkbox') filterApplied(filter, input.checked ? 'add' : 'remove', input.value);
      else if (filter === 'price') filterApplied('price', input.value === '' ? 'remove' : 'add'); // emptiness only, never the amount
    } catch (_) {
      /* tracking never breaks the page */
    }
  }
  function onFacetClick(event) {
    try {
      const t = event.target;
      if (!t || typeof t.closest !== 'function') return;
      // The product-type nav (bundle.js): read before its handler runs (capture phase), so `active` is the state the
      // tap changes. A type tapped again clears it; "View All" clears every type.
      const type = t.closest('.sofsy-product-type-nav [data-filter-type]');
      if (type) {
        const nav = type.closest('.sofsy-product-type-nav');
        const active = Array.prototype.filter
          .call(nav.querySelectorAll('[data-filter-type]'), (a) => a.parentElement && a.parentElement.classList.contains('sofsy-product-type-nav__item--active'))
          .map((a) => a.getAttribute('data-filter-type'))
          .filter(Boolean);
        const picked = type.getAttribute('data-filter-type') || '';
        if (!picked) {
          if (active.length) filterApplied('type', 'clear');
        } else filterApplied('type', active.indexOf(picked) >= 0 ? 'remove' : 'add', picked);
        return;
      }
      const remove = t.closest('[data-sofsy-track="collection.facet.remove.tap"]');
      if (remove) {
        filterApplied(filterKind(remove.getAttribute('data-sofsy-track-value')), 'remove');
        return;
      }
      if (t.closest('[data-sofsy-track="collection.facet.clear.tap"]')) filterApplied('other', 'clear');
    } catch (_) {
      /* tracking never breaks the page */
    }
  }

  // pdp.reviews.view {place}: a Reviews.io container ([data-reviews-io]) is 50% in view; once per page view.
  // pdp.reviews.load {ok, ms, place}: from the first container entering view, the widget renders content (ok: true,
  // ms) or has not within 8 s (ok: false, ms 8000); once per page view. The widget mounts in data-container-id's child
  // (bundle.js initReviewsLazyLoad); content = that child has elements.
  const REVIEWS_WAIT_MS = 8000;
  const reviewsPlace = (el) =>
    el.closest('modal-dialog, .product-popup-modal') ? 'popup' : el.closest('.reviews-accordion-content, [data-pdp-info]') ? 'tab' : 'section';
  const reviewsRendered = (el) => {
    const id = el.getAttribute('data-container-id');
    const mount = id && SAFE_ID.test(id) ? el.querySelector(`#${id}`) : el.querySelector('[id^="ReviewsWidget-"]');
    return !!(mount && mount.children && mount.children.length > 0);
  };
  const reviews = { loading: false };
  function watchReviews() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-reviews-io]'), (el) => {
      if (!watchOnce(el)) return;
      inView(el, 0.5, () => first('pdp.reviews.view') && emit('pdp.reviews.view', { place: reviewsPlace(el) }));
      inView(el, 0, () => {
        if (reviews.loading) return;
        reviews.loading = true;
        const place = reviewsPlace(el);
        const started = nowMs();
        let mo = null;
        let timer = 0;
        const done = (ok) => {
          if (mo) mo.disconnect();
          clearTimeout(timer);
          first('pdp.reviews.load') && emit('pdp.reviews.load', { ok, ms: ok ? Math.max(0, Math.round(nowMs() - started)) : REVIEWS_WAIT_MS, place });
        };
        if (reviewsRendered(el)) return done(true);
        mo = observe(el, { childList: true, subtree: true }, () => reviewsRendered(el) && done(true));
        timer = setTimeout(() => done(false), REVIEWS_WAIT_MS);
        return null;
      });
    });
  }

  // Email sign-up (spec 3.12). The footer form is sent to Klaviyo by assets/footer-signup.js (su202), which sets
  // #ContactFooter-success to opacity 1 only when Klaviyo accepts the address, #ContactFooter-error to opacity 1 when
  // the send fails, and marks an empty or malformed address field__input--error. Klaviyo forms report through
  // the window event klaviyoForms, of which only detail.type and detail.formId are read, plus, for a 'submit' from
  // sofsy's two sign-up pop-ups only (LEAD_POPUPS), the address in detail.metaData ($email, else email), solely to
  // hand it to signupSuccess (below). Nothing else in metaData (the phone, the rest) is ever touched.
  //   email.form.view {form, form_id?}       footer 50% in view, or a Klaviyo form opens; once per form per page view
  //   email.signup.success {form, form_id?, offer?, lead?}  once per form per page view (signupSuccess; lead only
  //                                                        while the lead setting is on)
  //   email.signup.fail {form, reason, offer?}       invalid_email | other; once per reason per page view
  //   offer: the footer only, 'gloves' | 'pct10' (the sign-up offer it showed, su202)
  //   (a failed footer send is reported as other)
  const KLAVIYO_FORM_ID = /^[A-Za-z0-9]{6}$/;

  /* ---------- sign-ups as leads: SofsyTrack.signupSuccess, the ONE decider (zao#617) ----------
   * Design: zao domains/sofsy/01-sales-marketing/shopify/analytics/SIGNUP_LEAD_CONVERSIONS_2026-10-05.md, sections
   * 2 and 9. Every sign-up Klaviyo ACCEPTED comes here: the footer and the welcome drawer from footer-signup.js's
   * shared subscribe() after a real 2xx (never the bot path, never on submit or a failed send), Klaviyo's two sign-up
   * pop-ups from their 'submit' event. It sends the sign-up's bus event (as before; plus lead: 1 | 0 ONLY while the
   * setting is on, so with it off the payload is exactly today's: the chopsticks receiver counts any unlisted prop
   * as dropped_field, and must accept `lead` (zao spec 9.2) before the setting is switched on), then, again ONLY while
   * the setting is on (off: no new window event at all), the window event 'sofsy:lead' {event_id, surface, form_id,
   * offer, entry, lead, em_google?} that assets/signup-conversions.js turns into the Google Ads conversion, GA4
   * sign_up and the Meta browser Lead (one event_id for all of them, and for the chopsticks Conversions API copy once
   * zao spec 9.2 is live; a bus event without `lead` must be read there as "not a lead").
   *
   * lead is 1 only when ALL of these hold (section 2.3), else 0:
   *   - the theme setting is on (window.SofsyLeadConfig.enabled === true, snippets/signup-conversions.liquid);
   *   - footer or drawer, or a Klaviyo 'submit' from Xkv52p / Y9SG6D (any other form id, back in stock included: 0);
   *   - not an internal browser (isInternal(): the sofsy_internal cookie or its mirror; test mode never lifts this);
   *   - a well-formed address that is not '+test' in its local part and not on a staff domain (sofsy.com, benmay.io,
   *     kobellakade.com, oomee.com): test mode, localStorage 'sofsy:lead-test' = '1', lets those two through;
   *   - no lead from this browser in the last 90 days (localStorage 'sofsy:lead_at', a timestamp only, written the
   *     moment lead is 1, before the hash wait; unreadable storage counts as "recent");
   *   - no lead already counted in this page view (leadThisPage): so even where the lead_at write fails (storage
   *     full or blocked while reads work) a page view counts at most one lead, whichever forms she uses.
   * The hashes (SHA-256 hex, crypto.subtle; given up after 5 s) are made only for a lead, and only with marketing AND
   * sale of data consent and no Global Privacy Control (unknown or a missing API means no), read again when the event
   * is sent: `em` (trim + lower case: Meta) on the bus event, `em_google` (the same, plus, for gmail.com /
   * googlemail.com only, no dots and no '+' suffix before the @: Google's normalisation, developers.google.com/
   * google-ads/api/docs/conversions/upload-online) on 'sofsy:lead'. The address is never kept. */
  const LEAD_POPUPS = Object.freeze(['Xkv52p', 'Y9SG6D']); // desktop, phone (footer-signup.js POPUP_FORMS)
  const LEAD_STAFF_DOMAINS = Object.freeze(['sofsy.com', 'benmay.io', 'kobellakade.com', 'oomee.com']);
  const LEAD_AT_KEY = 'sofsy:lead_at';
  const LEAD_TEST_KEY = 'sofsy:lead-test';
  const LEAD_GUARD_MS = 90 * 24 * 60 * 60 * 1000;
  const LEAD_HASH_WAIT_MS = 5000;
  const LEAD_SURFACES = Object.freeze(['footer', 'drawer', 'klaviyo']);
  let leadThisPage = false; // a lead was counted in this page view (whatever storage allowed)
  // The welcome drawer's entries (welcome-drawer.js ENTRIES), plus 'campaign': storefront PR #158's automatic opening
  // for a sign-up campaign visit. Sent as-is (bus `entry`, GA4 signup_entry); an unknown entry is dropped, not guessed.
  const DRAWER_ENTRIES = Object.freeze(['menu', 'auto', 'exit', 'campaign', 'tab']);
  const LEAD_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const leadEnabled = () => {
    try {
      const config = window.SofsyLeadConfig;
      return !!config && config.enabled === true;
    } catch (_) {
      return false;
    }
  };
  const leadTestMode = () => {
    try {
      return window.localStorage.getItem(LEAD_TEST_KEY) === '1';
    } catch (_) {
      return false;
    }
  };
  // true when a lead was counted from this browser in the last 90 days, or when it cannot be known.
  const leadRecent = () => {
    try {
      const raw = window.localStorage.getItem(LEAD_AT_KEY);
      if (raw === null || raw === '') return false;
      const at = Number(raw);
      return !Number.isFinite(at) || Date.now() - at < LEAD_GUARD_MS;
    } catch (_) {
      return true;
    }
  };
  const gpcOn = () => {
    try {
      const nav = window.navigator;
      return !!nav && nav.globalPrivacyControl === true;
    } catch (_) {
      return true; // unknown means no
    }
  };
  // Marketing AND sale of data, and no GPC, at the moment of asking. Unknown or a missing API means no.
  const userDataAllowed = () => {
    const c = consentNow();
    return !!c && c.m === 1 && c.s === 1 && !gpcOn();
  };
  const metaEmail = (raw) => (typeof raw === 'string' ? raw.trim().toLowerCase() : '');
  const googleEmail = (normal) => {
    const at = normal.lastIndexOf('@');
    if (at < 1) return normal;
    const domain = normal.slice(at + 1);
    if (domain !== 'gmail.com' && domain !== 'googlemail.com') return normal; // every other domain: as Meta's
    return normal.slice(0, at).replace(/\+.*$/, '').replace(/\./g, '') + normal.slice(at); // Gmail: no '+…', no dots
  };
  const staffDomain = (domain) => LEAD_STAFF_DOMAINS.some((d) => domain === d || domain.slice(-(d.length + 1)) === `.${d}`);
  const sha256Hex = (text) => {
    try {
      const subtle = window.crypto && window.crypto.subtle;
      const Enc = window.TextEncoder || (typeof TextEncoder === 'function' ? TextEncoder : null);
      if (!subtle || typeof subtle.digest !== 'function' || !Enc) return Promise.resolve(null);
      return Promise.resolve(subtle.digest('SHA-256', new Enc().encode(text)))
        .then((buffer) => Array.from(new Uint8Array(buffer), (b) => b.toString(16).padStart(2, '0')).join(''))
        .catch(() => null);
    } catch (_) {
      return Promise.resolve(null);
    }
  };
  // Both hashes, or null after LEAD_HASH_WAIT_MS (then the sign-up carries on without them).
  const leadHashes = (normal) =>
    new Promise((resolve) => {
      const timer = setTimeout(() => resolve(null), LEAD_HASH_WAIT_MS);
      Promise.all([sha256Hex(normal), sha256Hex(googleEmail(normal))])
        .then(([meta, google]) => {
          clearTimeout(timer);
          const ok = (h) => typeof h === 'string' && /^[0-9a-f]{64}$/.test(h);
          resolve(ok(meta) && ok(google) ? { meta, google } : null);
        })
        .catch(() => {
          clearTimeout(timer);
          resolve(null);
        });
    });
  // lead 1 | 0 and the reason (the reason is for the debug line only; never sent).
  const decideLead = (enabled, surface, formId, normal) => {
    if (!enabled) return [0, 'setting_off'];
    if (surface === 'klaviyo' && LEAD_POPUPS.indexOf(formId) < 0) return [0, 'not_a_signup_form'];
    if (isInternal()) return [0, 'internal'];
    if (!LEAD_EMAIL.test(normal)) return [0, 'no_address'];
    const at = normal.lastIndexOf('@');
    const local = normal.slice(0, at);
    const domain = normal.slice(at + 1);
    if ((local.indexOf('+test') > -1 || staffDomain(domain)) && !leadTestMode()) return [0, 'test_or_staff'];
    if (leadThisPage) return [0, 'already_this_page'];
    if (leadRecent()) return [0, 'within_90_days'];
    return [1, 'lead'];
  };
  const dispatchLead = (detail) => {
    try {
      if (typeof window.CustomEvent !== 'function' || typeof window.dispatchEvent !== 'function') return;
      window.dispatchEvent(new window.CustomEvent('sofsy:lead', { detail }));
    } catch (_) {
      /* tracking never breaks the page */
    }
  };

  // opts: {surface: 'footer' | 'drawer' | 'klaviyo', form_id (klaviyo), offer, entry (drawer), email}.
  // Resolves the event_id (or null when this sign-up was already reported in this page view).
  function signupSuccess(opts) {
    try {
      const o = opts && typeof opts === 'object' ? opts : {};
      const surface = LEAD_SURFACES.indexOf(o.surface) > -1 ? o.surface : null;
      if (!surface) return Promise.resolve(null);
      const klaviyoId = typeof o.form_id === 'string' && KLAVIYO_FORM_ID.test(o.form_id) ? o.form_id : null;
      // The existing once-per-form-per-page-view keys: the footer's opacity watcher and this share theirs.
      const key = surface === 'footer' ? 'email.success.footer' : surface === 'drawer' ? 'email.success.drawer' : `email.success.klaviyo.${klaviyoId}`;
      if (!first(key)) return Promise.resolve(null);
      const offer = o.offer === 'gloves' || o.offer === 'pct10' ? o.offer : null;
      const drawerEntry = DRAWER_ENTRIES.indexOf(o.entry) > -1 ? o.entry : null;
      const normal = metaEmail(o.email);
      const enabled = leadEnabled(); // read once: the same answer decides lead and whether the bus event says so
      const [lead, why] = decideLead(enabled, surface, klaviyoId, normal);
      if (lead === 1) {
        leadThisPage = true; // at once, before the hash wait: a second form in this page view is never a lead
        try {
          window.localStorage.setItem(LEAD_AT_KEY, String(Date.now())); // at once too: the next page views read it
        } catch (_) {
          /* storage full or blocked: leadThisPage still keeps this page view to one lead; the next page view may
             count again, so the 90-day guard holds only where storage can be written */
        }
      }
      if (debugOn()) console.debug('sofsyTrack lead', surface, klaviyoId || '', lead, why);
      const hashes = lead === 1 && userDataAllowed() ? leadHashes(normal) : Promise.resolve(null);
      return hashes
        .then((h) => {
          const withHash = !!h && lead === 1 && userDataAllowed(); // consent read again, at fire time
          let name = 'email.signup.success';
          let props;
          if (surface === 'drawer') {
            name = 'drawer.signup.success';
            props = {};
            if (offer) props.offer = offer;
            if (drawerEntry) props.entry = drawerEntry;
          } else if (surface === 'footer') {
            props = offer ? { form: 'footer', offer } : { form: 'footer' };
          } else {
            props = klaviyoId ? { form: 'klaviyo', form_id: klaviyoId } : { form: 'klaviyo' };
          }
          if (enabled) props.lead = lead; // setting off: today's shape exactly (no lead, and never em)
          const eventId = emit(name, props, null, null, false, withHash ? { em: h.meta } : null);
          if (!eventId) return null;
          const detail = {
            event_id: eventId,
            surface,
            form_id: surface === 'klaviyo' ? klaviyoId : surface,
            offer,
            entry: surface === 'drawer' ? drawerEntry : surface === 'footer' ? 'footer' : 'popup',
            lead
          };
          if (withHash) detail.em_google = h.google;
          if (enabled) dispatchLead(detail); // setting off: no new window event at all
          return eventId;
        })
        .catch(() => null);
    } catch (_) {
      return Promise.resolve(null);
    }
  }

  const shown = (el) => !!el && String((el.style && el.style.opacity) || '') === '1';
  function watchFooterForm() {
    const form = document.getElementById('ContactFooter');
    if (!form || !watchOnce(form)) return;
    inView(form, 0.5, () => first('email.view.footer') && emit('email.form.view', { form: 'footer' }));
    const success = document.getElementById('ContactFooter-success');
    const error = document.getElementById('ContactFooter-error');
    // su202: the footer's sign-up offer (A/B), read from the form at fire time; only the two known values, never typed text.
    const withOffer = (props) => {
      const offer = form.getAttribute('data-offer');
      return offer === 'gloves' || offer === 'pct10' ? Object.assign(props, { offer }) : props;
    };
    const fail = (reason) => first(`email.fail.footer.${reason}`) && emit('email.signup.fail', withOffer({ form: 'footer', reason }));
    // A fallback only: footer-signup.js reports a real 2xx through signupSuccess before it shows the thank-you, so this
    // finds the key taken. Without that call (an older footer-signup.js) it still reports the sign-up, never as a lead.
    const reported = () => signupSuccess({ surface: 'footer', offer: withOffer({}).offer });
    observe(success, { attributes: true, attributeFilter: ['style'] }, () => shown(success) && reported());
    observe(error, { attributes: true, attributeFilter: ['style'] }, () => shown(error) && fail('other'));
    const field = form.querySelector('input[name="email"], input[name="contact[email]"]');
    if (field && field.getAttribute('aria-describedby') === 'ContactFooter-success') reported();
    else if (field && field.getAttribute('aria-invalid') === 'true') fail('other');
    // footer-signup.js validates on the form's submit (a tap on the button, or Enter in the field); its verdict is
    // read one tick later. Both paths are watched; first() keeps it to one event per reason.
    const verdict = () =>
      setTimeout(() => {
        try {
          if (field && field.classList.contains('field__input--error')) fail('invalid_email');
        } catch (_) {
          /* tracking never breaks the page */
        }
      }, 0);
    document.addEventListener(
      'click',
      (event) => {
        const t = event.target;
        if (t && typeof t.closest === 'function' && t.closest('#ContactFooter button[type="submit"]')) verdict();
      },
      true
    );
    form.addEventListener('submit', verdict, true);
  }
  // The address a sign-up pop-up submitted, for signupSuccess only: metaData.$email, else metaData.email.
  const popupEmail = (meta) => {
    try {
      if (!meta || typeof meta !== 'object') return '';
      const primary = meta.$email; // each read once
      if (typeof primary === 'string') return primary;
      const fallback = meta.email;
      return typeof fallback === 'string' ? fallback : '';
    } catch (_) {
      return '';
    }
  };
  function onKlaviyoForm(event) {
    try {
      const detail = event && event.detail;
      if (!detail || typeof detail !== 'object') return;
      const type = detail.type;
      const formId = typeof detail.formId === 'string' && KLAVIYO_FORM_ID.test(detail.formId) ? detail.formId : null;
      const props = formId ? { form: 'klaviyo', form_id: formId } : { form: 'klaviyo' };
      if (type === 'open' || type === 'embedOpen') first(`email.view.klaviyo.${formId}`) && emit('email.form.view', props);
      else if (type === 'submit') signupSuccess({ surface: 'klaviyo', form_id: formId, email: LEAD_POPUPS.indexOf(formId) > -1 && leadEnabled() ? popupEmail(detail.metaData) : '' });
    } catch (_) {
      /* tracking never breaks the page */
    }
  }

  // notify.request.success / fail for the email-only back-in-stock form (snippets/klaviyo-back-in-stock-form.liquid,
  // sent by bundle.js notifyMeSendForm, which shows .success-message or .error-message with display: block). The
  // notify sheet's own answers are reported by assets/notify-me.js. One event per message shown.
  function watchBisForm() {
    const root = document.querySelector('.klaviyo-back-in-stock-form');
    if (!root || !watchOnce(root)) return;
    const variant = () => {
      const input = root.querySelector('input[name="variant"]');
      return input ? positiveId(input.value) : null;
    };
    const watch = (selector, report) => {
      const el = root.querySelector(selector);
      let on = false;
      observe(el, { attributes: true, attributeFilter: ['style'] }, () => {
        const now = String((el.style && el.style.display) || '') === 'block';
        if (now && !on) report();
        on = now;
      });
    };
    watch('.success-message', () => emit('notify.request.success', { channel: 'email', place: 'email_form', variant_id: variant() }));
    watch('.error-message', () => emit('notify.request.fail', { reason: 'other', place: 'email_form' }));
  }

  // account.login.submit {place}: the account drawer's or the login page's #customer_login is submitted (the drawer's
  // email step included); never its fields. The drawer's register step (data-action /account) is not a login.
  function onSubmit(event) {
    try {
      const form = event.target;
      if (!form || form.id !== 'customer_login' || typeof form.closest !== 'function') return;
      if (form.getAttribute('data-action') === '/account') return;
      emit('account.login.submit', { place: form.closest('#drawer-account, [data-account-drawer-target]') ? 'drawer' : 'page' });
    } catch (_) {
      /* tracking never breaks the page */
    }
  }

  function watchOutcomes() {
    // page.not_found.view: the 404 template rendered (#clarity-ctx template); once per page view.
    if (pageContext.template === '404') first('page.not_found') && emit('page.not_found.view', {});
    searchResults();
    watchPredictive();
    watchReviews();
    watchFooterForm();
    watchBisForm();
  }
  function listenOutcomes() {
    if (typeof document.addEventListener !== 'function' || typeof window.addEventListener !== 'function') return;
    document.addEventListener('change', onFacetChange, true);
    document.addEventListener('click', onFacetClick, true);
    document.addEventListener('submit', onSubmit, true);
    window.addEventListener('klaviyoForms', onKlaviyoForm);
    // Markup that arrives later (a colour swap re-renders the product section; predictive search binds on 'load').
    const again = () =>
      domReady(() => {
        watchPredictive();
        watchReviews();
        watchBisForm();
      });
    document.addEventListener('sectionReloadFinished', again);
    document.addEventListener('shopify:section:load', again);
    window.addEventListener('load', again);
  }
  try {
    listenOutcomes();
  } catch (_) {
    /* tracking never breaks the page, nor the sinks below */
  }


  document.addEventListener('click', onTap, true);
  document.addEventListener('change', onChange, true);
  domReady(watchPage);
  domReady(watchGallery);
  domReady(watchOutcomes);

  startGate();
  if (internalWritten || (!internalCleared && readCookie(INTERNAL_COOKIE) === '1')) {
    toClarity(['set', 'traffic_type', 'internal']);
  }
  // A/B arms as a Clarity tag (zao#612), so recordings can be filtered by arm; same consent gate and queue.
  if (expNow()) toClarity(['set', 'exp', expNow()]);
  // Shopify injects the admin and preview bars after load: mark then, once (the marking itself is above).
  try {
    window.addEventListener(
      'load',
      () =>
        setTimeout(() => {
          try {
            if (internalCleared || isInternal() || !adminContext()) return;
            internalNow = true;
            internalWritten = true;
            writeMark(true);
            toClarity(['set', 'traffic_type', 'internal']);
          } catch (_) {
            /* tracking never breaks the page */
          }
        }, ADMIN_BAR_WAIT_MS),
      { once: true }
    );
  } catch (_) {
    /* the next page view marks it */
  }

  window.sofsyTrack = sofsyTrack;
  window.SofsyTrack = Object.freeze({
    names: () => Object.keys(REGISTRY),
    taxonomy: () => Object.keys(TAXONOMY),
    aliases: () => Object.assign({}, ALIASES),
    clarityFlag: (name) => {
      const entry = resolve(name);
      return entry ? entry.clarity : null;
    },
    recent: () => recent.slice(),
    gateState: () => gate.state,
    pageViewId: () => pageViewId,
    isInternal, // the one reader for this page view (cookie, mirror, or a page-view-only signal); sofsyConsent too
    untagged,
    signupSuccess // the one lead decider (footer-signup.js subscribe(); Klaviyo's pop-ups above)
  });
})();
